webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(120);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _jsCookie = __webpack_require__(97);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	__webpack_require__(480);
	
	var _elementUi = __webpack_require__(87);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(479);
	
	__webpack_require__(496);
	
	var _en = __webpack_require__(465);
	
	var _en2 = _interopRequireDefault(_en);
	
	__webpack_require__(482);
	
	__webpack_require__(497);
	
	__webpack_require__(499);
	
	__webpack_require__(498);
	
	var _App = __webpack_require__(559);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(45);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(46);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(385);
	
	var _jquery = __webpack_require__(151);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(405);
	
	var _filters = __webpack_require__(384);
	
	var filters = _interopRequireWildcard(_filters);
	
	var _vueTelInput = __webpack_require__(109);
	
	var _vueTelInput2 = _interopRequireDefault(_vueTelInput);
	
	var _underscore = __webpack_require__(542);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	__webpack_require__(483);
	
	var _vueGooglemaps = __webpack_require__(309);
	
	var _vueGooglemaps2 = _interopRequireDefault(_vueGooglemaps);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.jQuery = _jquery2.default;
	window.$ = _jquery2.default;
	
	_vue2.default.use(_elementUi2.default, {
	  locale: _en2.default,
	  size: _jsCookie2.default.get('size') || 'large' });
	
	(0, _keys2.default)(filters).forEach(function (key) {
	  _vue2.default.filter(key, filters[key]);
	});
	
	var VueScrollTo = __webpack_require__(613);
	_vue2.default.use(VueScrollTo);
	
	_vue2.default.use(VueScrollTo, {
	  container: 'body',
	  duration: 500,
	  easing: 'ease',
	  offset: 0,
	  force: true,
	  cancelable: true,
	  onStart: false,
	  onDone: false,
	  onCancel: false,
	  x: false,
	  y: true
	});
	
	_vue2.default.use(_underscore2.default);
	
	_vue2.default.use(_vueGooglemaps2.default, {
	  load: {
	    apiKey: 'AIzaSyDQJx-KDJUimSyyVUwOBRrrzTG22-rvz18',
	
	    libraries: ['places'],
	
	    useBetaRenderer: false
	  }
	});
	
	
	_vue2.default.mixin({
	  data: function data() {
	    return {
	      phone_format: '',
	      preferred_countries: [],
	      only_countries: ['us', 'in'],
	      default_country: 'US',
	      disabled_fetching_country: true
	    };
	  },
	
	  computed: {
	    isLoggedIn: function isLoggedIn() {
	      return this.$store.state.user.user_id ? true : false;
	    },
	    userId: function userId() {
	      return this.$store.state.user.user_id;
	    },
	    userName: function userName() {
	      return this.$store.state.user.name;
	    }
	  },
	  methods: {
	    getMilliseconds: function getMilliseconds() {
	      var d = new Date();
	      return d.getMilliseconds();
	    },
	    diffHours: function diffHours(date_from) {
	      return Math.floor(Math.abs(+new Date() - +new Date(date_from)) / 36e5);
	    },
	    calculateReservationTax: function calculateReservationTax(taxableAmount, taxPercent) {
	      return this.priceOnly(taxableAmount * taxPercent / 100);
	    },
	    calculateReservationServiceFee: function calculateReservationServiceFee(totalAmount, serviceFeePercent) {
	      return this.priceOnly(totalAmount * serviceFeePercent / 100);
	    },
	    calculateReservationCommissionAmount: function calculateReservationCommissionAmount(totalSeatPrice, reservationCommission, reservationCommissionType) {
	      var amount = 0;
	
	      if (reservationCommissionType === 'flat') {
	        amount = this.priceOnly(reservationCommission);
	      } else {
	        amount = this.priceOnly(totalSeatPrice * reservationCommission / 100);
	      }
	      return amount;
	    },
	    onInputPhone: function onInputPhone(_ref) {
	      var number = _ref.number,
	          isValid = _ref.isValid,
	          country = _ref.country;
	
	      if (isValid) {
	        this.postForm.phone_number = number.replace(country.dialCode, '').replace('+', '');
	        this.postForm.phone_isd = country.dialCode;
	      }
	    },
	    onValidatePhone: function onValidatePhone(_ref2) {
	      var number = _ref2.number,
	          isValid = _ref2.isValid,
	          country = _ref2.country;
	
	      if (isValid) {
	        this.validPhone = true;
	      } else {
	        this.validPhone = false;
	      }
	    },
	    formatPhoneNumber: function formatPhoneNumber(_ref3) {
	      var number = _ref3.number,
	          isValid = _ref3.isValid,
	          country = _ref3.country;
	
	      this.phone_number = country.dialCode + number;
	    },
	    validatePhone: function validatePhone() {
	      if (this.rules.phone_number[0].required && this.postForm.phone_number !== '' && this.validPhone) {
	        return true;
	      } else if (!this.rules.phone_number[0].required && this.postForm.phone_number === '') {
	        return true;
	      } else if (!this.rules.phone_number[0].required && this.postForm.phone_number !== '' && this.validPhone) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    priceOnly: function priceOnly(str) {
	      if (str) {
	        str = str.toString();
	        return parseFloat(str.replace(/[^\d.]/g, ''));
	      }
	      return 0;
	    },
	    formatPrice: function formatPrice(price, currency) {
	      return (currency ? currency : '$') + this.priceOnly(price).toFixed(2);
	    },
	    convertDateFormat: function convertDateFormat(str) {
	      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	      var date = new Date(str);
	      var mnth = ('0' + (date.getMonth() + 1)).slice(-2);
	      var day = ('0' + date.getDate()).slice(-2);
	      if (format == 1) {
	        str = [mnth, day, date.getFullYear()].join('/');
	      } else if (format == 2) {
	        str = [date.getFullYear(), mnth, day].join('-');
	      }
	      return str;
	    },
	    validationScrollTo: function validationScrollTo(id) {
	      this.$scrollTo(id, 500);
	    },
	    validationErrors: function validationErrors(err) {
	      var _this = this;
	
	      this.validationScrollTo('#postForm');
	
	      _underscore._.each(this.p__errors, function (element, index) {
	        _this.p__errors[index] = '';
	      });
	      var messages = [];
	      _underscore._.each(JSON.parse(err), function (element, index) {
	        if (!_this.p__errors.hasOwnProperty(index)) {
	          messages.push(element[0]);
	        } else {
	          _this.p__errors[index] = element[0];
	        }
	      });
	      if (messages.length > 0) {
	        this.flashError(messages.filter(this.onlyUnique).join(', '));
	      }
	    },
	    resetFormErrors: function resetFormErrors() {
	      var _t = this;
	      _underscore._.each(_t.p__errors, function (element, index) {
	        _t.p__errors[index] = '';
	      });
	    },
	    onlyUnique: function onlyUnique(value, index, self) {
	      return self.indexOf(value) === index;
	    },
	
	    flashSuccess: function flashSuccess(message, title) {
	      this.$notify.success({
	        title: title || 'Success',
	        message: message || ''
	      });
	    },
	
	    flashError: function flashError(message, title) {
	      this.$notify.error({
	        title: title || 'Error',
	        message: message || ''
	      });
	    },
	
	    flashInfo: function flashInfo(message, title) {
	      this.$notify.info({
	        title: title || 'Info',
	        message: message || ''
	      });
	    }
	  }
	});
	
	_vue2.default.config.productionTip = false;
	
	_router2.default.beforeEach(function (_ref4, from, next) {
	  var meta = _ref4.meta,
	      path = _ref4.path;
	
	  if (path === '/home') {
	    document.body.classList.add("home");
	    document.body.classList.remove("page");
	  } else {
	    document.body.classList.remove("home");
	    document.body.classList.add("page");
	  }
	  next();
	});
	
	new _vue2.default({
	  el: '#app',
	  router: _router2.default,
	  store: _store2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(47);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(336);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _elementUi = __webpack_require__(87);
	
	var _store = __webpack_require__(46);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _auth = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var service = _axios2.default.create({
	  baseURL: ("https://api.opencabana.com/web/"),
	  timeout: 100000 });
	
	service.interceptors.request.use(function (config) {
	  if (_store2.default.getters.token) {
	    config.headers['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
	
	    config.headers['Access-Control-Allow-Headers'] = 'Authorization';
	  }
	  return config;
	}, function (error) {
	  console.log(error);
	  _promise2.default.reject(error);
	});
	
	service.interceptors.response.use(function (response) {
	  return response;
	}, function (error) {
	  console.log('err' + error);
	  (0, _elementUi.Message)({
	    message: error.message,
	    type: 'error',
	    duration: 5 * 1000
	  });
	  return _promise2.default.reject(error);
	});
	
	exports.default = service;

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = store;
	exports.confirmReservation = confirmReservation;
	exports.sendConfirmReservationEmail = sendConfirmReservationEmail;
	exports.getAvailableSeats = getAvailableSeats;
	exports.getReservations = getReservations;
	exports.getConfirmation = getConfirmation;
	exports.cancelReservation = cancelReservation;
	
	var _request = __webpack_require__(32);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function store(data) {
	  return (0, _request2.default)({
	    url: 'reservations/create',
	    method: 'post',
	    data: data
	  });
	}
	
	function confirmReservation(data) {
	  return (0, _request2.default)({
	    url: 'reservations/confirm',
	    method: 'post',
	    data: data
	  });
	}
	
	function sendConfirmReservationEmail(reservation_id) {
	  return (0, _request2.default)({
	    url: 'reservations/send-confirm-email/' + reservation_id,
	    method: 'post'
	  });
	}
	
	function getAvailableSeats(locationId, dates, timezoneId, seatTypeOptionId) {
	  if (!dates) {
	    dates = dates.join(',');
	  }
	  return (0, _request2.default)({
	    url: 'locations/' + locationId + '/' + dates + '/available-seats?timezone_id=' + timezoneId + '&seat_type_option_id=' + seatTypeOptionId,
	    method: 'get'
	  });
	}
	
	function getReservations(user_id) {
	  return (0, _request2.default)({
	    url: 'reservations',
	    method: 'get'
	  });
	}
	
	function getConfirmation(id) {
	  return (0, _request2.default)({
	    url: 'reservations/confirmation/' + id,
	    method: 'get'
	  });
	}
	
	function cancelReservation(reservation_id, data) {
	  return (0, _request2.default)({
	    url: 'reservations/cancel/' + reservation_id,
	    method: 'post',
	    data: data
	  });
	}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.constantRouterMap = undefined;
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(612);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Layout = __webpack_require__(565);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _index = __webpack_require__(563);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _list = __webpack_require__(572);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _details = __webpack_require__(571);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _index3 = __webpack_require__(584);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _confirmation = __webpack_require__(582);
	
	var _confirmation2 = _interopRequireDefault(_confirmation);
	
	var _success = __webpack_require__(585);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _index5 = __webpack_require__(560);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(564);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _apps = __webpack_require__(575);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _privacy = __webpack_require__(579);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	var _terms = __webpack_require__(580);
	
	var _terms2 = _interopRequireDefault(_terms);
	
	var _contact = __webpack_require__(578);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _cabanaappPrivacy = __webpack_require__(576);
	
	var _cabanaappPrivacy2 = _interopRequireDefault(_cabanaappPrivacy);
	
	var _cabanaappTerms = __webpack_require__(577);
	
	var _cabanaappTerms2 = _interopRequireDefault(_cabanaappTerms);
	
	var _index9 = __webpack_require__(574);
	
	var _index10 = _interopRequireDefault(_index9);
	
	var _authredirect = __webpack_require__(573);
	
	var _authredirect2 = _interopRequireDefault(_authredirect);
	
	var _index11 = __webpack_require__(581);
	
	var _index12 = _interopRequireDefault(_index11);
	
	var _ = __webpack_require__(562);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(561);
	
	var _4 = _interopRequireDefault(_3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var constantRouterMap = exports.constantRouterMap = [{
	  path: '',
	  component: _Layout2.default,
	  redirect: 'home',
	  children: [{
	    path: '/home',
	    name: 'home',
	    component: _index2.default,
	    hidden: true
	  }, {
	    path: '/login',
	    component: _index10.default,
	    hidden: true
	  }, {
	    path: '/dashboard',
	    component: _index6.default,
	    hidden: true
	  }]
	}, {
	  path: '/locations',
	  component: _Layout2.default,
	  hidden: true,
	  children: [{
	    path: '',
	    name: 'LocationList',
	    component: _list2.default,
	    hidden: true
	  }, {
	    path: ':slug',
	    name: "LocationSlug",
	    component: _details2.default,
	    hidden: true
	  }]
	}, {
	  path: '/reservations',
	  component: _Layout2.default,
	  hidden: true,
	  children: [{
	    path: ':slug',
	    name: 'ReservationsSlug',
	    component: _index4.default,
	    hidden: true
	  }, {
	    path: 'confirmation/:id',
	    component: _confirmation2.default,
	    hidden: true
	  }, {
	    path: 'success/:id',
	    component: _success2.default,
	    hidden: true
	  }]
	}, {
	  path: '/hotel-partners',
	  component: _Layout2.default,
	  hidden: true,
	  children: [{
	    path: '/',
	    component: _index8.default,
	    hidden: true
	  }]
	}, {
	  path: '/pages',
	  component: _Layout2.default,
	  hidden: true,
	  children: [{
	    path: 'apps',
	    component: _apps2.default,
	    hidden: true
	  }, {
	    path: 'privacy',
	    component: _privacy2.default,
	    hidden: true
	  }, {
	    path: 'terms',
	    component: _terms2.default,
	    hidden: true
	  }, {
	    path: 'contact',
	    component: _contact2.default,
	    hidden: true
	  }, {
	    path: 'cabanaapp-privacy',
	    component: _cabanaappPrivacy2.default,
	    hidden: true
	  }, {
	    path: 'cabanaapp-terms',
	    component: _cabanaappTerms2.default,
	    hidden: true
	  }]
	}, {
	  path: '/login',
	  component: _index10.default,
	  hidden: true
	}, {
	  path: '/auth-redirect',
	  component: _authredirect2.default,
	  hidden: true
	}, {
	  path: '/redirect',
	  component: _Layout2.default,
	  hidden: true,
	  children: [{
	    path: '/redirect/:path*',
	    component: _index12.default
	  }]
	}, {
	  path: '/404',
	  component: _2.default,
	  hidden: true
	}, {
	  path: '/401',
	  component: _4.default,
	  hidden: true
	}];
	
	exports.default = new _vueRouter2.default({
	  scrollBehavior: function scrollBehavior() {
	    return { y: 0 };
	  },
	  routes: constantRouterMap
	});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(110);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _getters = __webpack_require__(386);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var modulesFiles = __webpack_require__(617);
	
	var modules = modulesFiles.keys().reduce(function (modules, modulePath) {
	  var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
	  var value = modulesFiles(modulePath);
	  modules[moduleName] = value.default;
	  return modules;
	}, {});
	
	var store = new _vuex2.default.Store({
	  modules: modules,
	  getters: _getters2.default
	});
	
	exports.default = store;

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocationsPulldown = getLocationsPulldown;
	exports.getLocations = getLocations;
	exports.getLocationDetails = getLocationDetails;
	exports.getSeatTypes = getSeatTypes;
	
	var _request = __webpack_require__(32);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLocationsPulldown() {
	  return (0, _request2.default)({
	    url: 'locations/pulldown',
	    method: 'get'
	  });
	}
	
	function getLocations() {
	  return (0, _request2.default)({
	    url: 'locations/list',
	    method: 'get'
	  });
	}
	
	function getLocationDetails(slug, dateFrom, dateTo) {
	  return (0, _request2.default)({
	    url: 'locations/' + slug + '?date_from=' + dateFrom + '&date_to=' + dateTo,
	    method: 'get'
	  });
	}
	
	function getSeatTypes(locationId) {
	  return (0, _request2.default)({
	    url: 'seat-types/' + locationId,
	    method: 'get'
	  });
	}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getToken = getToken;
	exports.setToken = setToken;
	exports.removeToken = removeToken;
	
	var _jsCookie = __webpack_require__(97);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TokenKey = 'Admin-Token';
	
	function getToken() {
	  return _jsCookie2.default.get(TokenKey);
	}
	
	function setToken(token) {
	  return _jsCookie2.default.set(TokenKey, token);
	}
	
	function removeToken() {
	  return _jsCookie2.default.remove(TokenKey);
	}

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendVerificationCode = sendVerificationCode;
	exports.loginByPhone = loginByPhone;
	exports.logout = logout;
	exports.getUserInfo = getUserInfo;
	
	var _request = __webpack_require__(32);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sendVerificationCode(data) {
	  return (0, _request2.default)({
	    url: 'guest/login',
	    method: 'post',
	    data: data
	  });
	}
	
	function loginByPhone(data) {
	  return (0, _request2.default)({
	    url: 'guest/login',
	    method: 'post',
	    data: data
	  });
	}
	
	function logout() {
	  return (0, _request2.default)({
	    url: 'guest/logout',
	    method: 'post'
	  });
	}
	
	function getUserInfo() {
	  return (0, _request2.default)({
	    url: 'guest/user-info',
	    method: 'get'
	  });
	}

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports) {

	module.exports = {"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","[25689]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25689]"]]]],"BL":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-79]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}",[10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"],0,0,0,["600[2-9]\\d{6}"]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1 $2",["[146][2-9]|[2578]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["[39]"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:1\\d|2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|[23]1|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-59]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[47]\\d{6}|76\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-24-69]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94|80\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d\\d|606)\\d{5}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([25-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|55\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[38]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]","5(?:29|38)[89]0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[01]\\d|6[1267]|7[0-57]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[57-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670"],"MQ":["596","00","(?:69|80)\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9])|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","[2-57-9]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",[5,6,7,8,9,10],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|59"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,0," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","(?:[45]|80\\d\\d)\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",[7,8,9],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]]],"RE":["262","00","9769\\d{5}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]"],"RO":["40","00","(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","8000\\d{3}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-4]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:00|[1-57-9]\\d)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]","4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["[3-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}",[10],[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","(?:33|55|[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:005|[1-9]\\d\\d)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:005|[1-9]\\d\\d)\\d{5}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["4"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?",[9,10,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[35]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}}

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/diplomat_logo.b6da01b.png";

/***/ }),
/* 309 */,
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(488)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(355),
	  /* template */
	  __webpack_require__(593),
	  /* scopeId */
	  "data-v-36e82035",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App'
	};

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Hamburger',
	  props: {
	    isActive: {
	      type: Boolean,
	      default: false
	    },
	    toggleClick: {
	      type: Function,
	      default: null
	    }
	  }
	};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reservation = __webpack_require__(44);
	
	exports.default = {
	  name: 'reservationLists',
	  data: function data() {
	    return {
	      reservationLists: [],
	      cancelAlertDialog: false
	    };
	  },
	  created: function created() {
	    this.getList();
	  },
	
	  methods: {
	    getList: function getList() {
	      var _this = this;
	
	      this.loading = true;
	      (0, _reservation.getReservations)(this.userId).then(function (response) {
	        if (response.data.success == true) {
	          _this.reservationLists = response.data.data;
	        }
	        _this.loading = false;
	      });
	    },
	    cancelReservation: function cancelReservation(row) {
	      var _this2 = this;
	
	      var refund = false;
	      var cancelMsg = '';
	      var hours = Math.floor(Math.abs(+new Date() - +new Date(row.date_from)) / 36e5);
	      if (hours > row.location_refund_within) {
	        cancelMsg = 'As per our cancelation policy, we will refund your money.';
	        refund = true;
	      } else {
	        cancelMsg = 'As per our cancelation policy, we can not refund your money.';
	        refund = false;
	      }
	
	      if (cancelMsg) {
	        this.$confirm(cancelMsg, 'Warning', {
	          confirmButtonText: 'Yes',
	          cancelButtonText: 'No',
	          type: 'warning'
	        }).then(function () {
	          _this2.loading = true;
	          (0, _reservation.cancelReservation)(row.id, { status: 'cancel', refund: refund }).then(function (response) {
	            if (response.data.success === true) {
	              _this2.flashSuccess(response.data.message);
	              _this2.getList();
	            }
	            _this2.loading = false;
	          });
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Page401',
	  computed: {
	    message: function message() {
	      return 'Sorry page not found!';
	    }
	  }
	};

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Page404',
	  computed: {
	    message: function message() {
	      return 'Sorry page not found!';
	    }
	  }
	};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Home',
	  data: function data() {
	    return {
	      slideArrow: 'never',
	      slideIndicator: 'none',
	      image: "https://opencabana.com/assets/images/diplo.jpg",
	      slides: [__webpack_require__(548), __webpack_require__(549), __webpack_require__(550), __webpack_require__(551), __webpack_require__(552)]
	    };
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(33);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _hotel_partner = __webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultForm = {
	  hname: '',
	  fname: '',
	  lname: '',
	  title: '',
	  email: '',
	  info: ''
	};
	
	exports.default = {
	  name: 'HotelPartner',
	  data: function data() {
	    return {
	      loading: false,
	      p__errors: {},
	      postForm: (0, _assign2.default)({}, defaultForm),
	      rules: {
	        hname: {
	          'required': true,
	          'message': 'Please enter Hotel Name.',
	          'trigger': 'blur'
	        },
	        fname: {
	          'required': true,
	          'message': 'Please enter your First Name.',
	          'trigger': 'blur'
	        },
	        lname: {
	          'required': true,
	          'message': 'Please enter your Last Name.',
	          'trigger': 'blur'
	        },
	        title: {
	          'required': true,
	          'message': 'Please enter your Title.',
	          'trigger': 'blur'
	        },
	        email: {
	          'required': true,
	          'message': 'Please enter your Email.',
	          'trigger': 'blur'
	        }
	      }
	    };
	  },
	
	  methods: {
	    submitForm: function submitForm() {
	      var _this = this;
	
	      this.$refs.postForm.validate(function (valid) {
	        if (valid) {
	          _this.loading = true;
	          (0, _hotel_partner.store)(_this.postForm).then(function (response) {
	            if (response.data.success === true) {
	              _this.flashSuccess(response.data.message);
	              _this.$router.push('home');
	            } else {
	              _this.validationErrors(response.data.message);
	            }
	            _this.loading = false;
	          }).catch(function (err) {
	            console.log(err);
	          });
	        } else {
	          _this.validationScrollTo('#postForm');
	          return false;
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(391);
	
	var _ResizeHandler = __webpack_require__(392);
	
	var _ResizeHandler2 = _interopRequireDefault(_ResizeHandler);
	
	var _index = __webpack_require__(383);
	
	var _Footer = __webpack_require__(568);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Layout',
	  components: {
	    Sidebar: _components.Sidebar,
	    Navbar: _components.Navbar,
	    AppMain: _components.AppMain,
	    Footer: _Footer2.default
	  },
	  mixins: [_ResizeHandler2.default],
	  created: function created() {
	    (0, _index.getSettings)().then(function (response) {
	      window.SETTINGS = response.data.data;
	    });
	  },
	
	  computed: {
	    sidebar: function sidebar() {
	      return this.$store.state.app.sidebar;
	    },
	    device: function device() {
	      return this.$store.state.app.device;
	    },
	    seeNavbarSidebar: function seeNavbarSidebar() {
	      var pathName = ['LocationSlug', 'ReservationsSlug'];
	
	      return pathName.includes(this.$route.name);
	    },
	    classObj: function classObj() {
	      return {
	        hideSidebar: !this.sidebar.opened,
	        openSidebar: this.sidebar.opened,
	        withoutAnimation: this.sidebar.withoutAnimation,
	        mobile: this.device === 'mobile'
	      };
	    }
	  },
	  methods: {
	    handleClickOutside: function handleClickOutside() {
	      this.$store.dispatch('closeSideBar', { withoutAnimation: false });
	    }
	  }
	};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AppFooter',
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(new Date()).format('YYYY')
	    };
	  }
	};

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "AppMain",
	  computed: {
	    key: function key() {
	      return this.$route.fullPath;
	    },
	    seeNavbarSidebar: function seeNavbarSidebar() {
	      var pathName = ['LocationSlug', 'ReservationsSlug'];
	      return pathName.includes(this.$route.name);
	    }
	  }
	};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Footer",
	  methods: {
	    openSidebarLink: function openSidebarLink(page) {
	      if (page === "home") {
	        this.$router.push("/home");
	      } else {
	        this.$router.push("/" + page);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(new Date()).format("YYYY")
	    };
	  }
	};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(29);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(110);
	
	var _Hamburger = __webpack_require__(310);
	
	var _Hamburger2 = _interopRequireDefault(_Hamburger);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(new Date()).format('YYYY')
	    };
	  },
	
	  components: {
	    Hamburger: _Hamburger2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['sidebar']), {
	    isCollapse: function isCollapse() {
	      return !this.sidebar.opened;
	    }
	  }),
	  methods: {
	    toggleSideBar: function toggleSideBar() {
	      this.$store.dispatch('toggleSideBar');
	    },
	    toggleNavbarMenu: function toggleNavbarMenu() {
	      console.log('jkjk');
	    },
	    openSidebarLink: function openSidebarLink(page) {
	      $('#navbarSupportedContent').toggleClass('show');
	      if (page === 'home') {
	        this.$router.push('/home');
	      } else {
	        this.$router.push('/' + page);
	      }
	    },
	    logout: function logout() {
	      var _this = this;
	
	      this.$store.dispatch('user/Logout').then(function () {
	        _this.$router.push('/home');
	        location.reload();
	      });
	    }
	  }
	};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(29);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(110);
	
	var _Hamburger = __webpack_require__(310);
	
	var _Hamburger2 = _interopRequireDefault(_Hamburger);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      date: (0, _moment2.default)(new Date()).format("YYYY")
	    };
	  },
	
	  components: {
	    Hamburger: _Hamburger2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["sidebar"]), {
	    isCollapse: function isCollapse() {
	      return !this.sidebar.opened;
	    },
	    routeName: function routeName() {
	      return this.$route.name;
	    }
	  }),
	  methods: {
	    toggleSideBar: function toggleSideBar() {
	      this.$store.dispatch("toggleSideBar");
	    },
	    openSidebarLink: function openSidebarLink(page) {
	      if (page === "home") {
	        this.$router.push("/home");
	      } else {
	        this.$router.push("/" + page);
	      }
	    },
	    logout: function logout() {
	      var _this = this;
	
	      this.$store.dispatch("user/Logout").then(function () {
	        _this.$router.push("/home");
	        location.reload();
	      });
	    }
	  }
	};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _location = __webpack_require__(66);
	
	var _vue = __webpack_require__(313);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _daygrid = __webpack_require__(311);
	
	var _daygrid2 = _interopRequireDefault(_daygrid);
	
	var _interaction = __webpack_require__(312);
	
	var _interaction2 = _interopRequireDefault(_interaction);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Home",
	  components: {
	    FullCalendar: _vue2.default },
	  data: function data() {
	    return {
	      imgHight: window.innerWidth,
	      calendarPlugins: [_daygrid2.default, _interaction2.default],
	      dialogVisible: false,
	      dialogData: {},
	      loading: false,
	      autoplay: false,
	      calendarWeekends: true,
	      locationDetails: "",
	      locationSlug: "",
	      seatTypes: [],
	      seatTypeOptions: [],
	      locationImages: [{
	        slug: "diplomat",
	        images: [__webpack_require__(545), __webpack_require__(546), __webpack_require__(547)]
	      }, {
	        slug: "legoland",
	        images: [__webpack_require__(553), __webpack_require__(554), __webpack_require__(555)]
	      }],
	      pickerOptions: {
	        disabledDate: function disabledDate(date) {
	          var dated = (0, _moment2.default)(new Date()).format("YYYY-MM-DD");
	          var comapare = (0, _moment2.default)(new Date(date)).format("YYYY-MM-DD");
	          return new Date(dated) > new Date(comapare);
	        }
	      },
	      dateFrom: '',
	      dateTo: '',
	      dateFromTo: ['', '']
	    };
	  },
	  created: function created() {
	    this.loading = true;
	    this.locationSlug = this.$route.params.slug;
	    if (this.$route.query.date_from) {
	      this.dateFrom = (0, _moment2.default)(this.$route.query.date_from, "YYYY-MM-DD hh:mm:ss").format("MM/DD/YYYY hh:mm:ss");
	    }
	    if (this.$route.query.date_to) {
	      this.dateTo = (0, _moment2.default)(this.$route.query.date_to, "YYYY-MM-DD hh:mm:ss").format("MM/DD/YYYY hh:mm:ss");
	    }
	    this.dateFromTo = [this.dateFrom, this.dateTo];
	    this.handleLocationDetails(this.dateFrom, this.dateTo);
	    window.addEventListener("resize", this.changeImgHeight);
	  },
	
	  methods: {
	    handleOpenDialog: function handleOpenDialog(data) {
	      this.dialogData = data;
	      this.dialogVisible = true;
	    },
	    handleClose: function handleClose() {
	      this.dialogVisible = false;
	    },
	    changeImgHeight: function changeImgHeight() {
	      this.imgHight = window.innerWidth;
	    },
	    handleDateClick: function handleDateClick(arg) {
	      this.handleLocationDetails(arg[0], arg[1]);
	    },
	    handleBookNow: function handleBookNow(seatTypeOptionId) {
	      console.log(this.dateFrom);
	      if (this.dateFrom == 'Invalid date' || this.dateTo == 'Invalid date') {
	        alert('Please select your date(s)');
	      } else {
	        this.$router.push("/reservations/" + this.locationSlug + "?" + "date_from=" + (0, _moment2.default)(this.dateFrom, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss") + "&date_to=" + (0, _moment2.default)(this.dateTo, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss") + "&seat_type_option_id=" + seatTypeOptionId + "&t=" + this.getMilliseconds());
	      }
	    },
	    handleLocationDetails: function handleLocationDetails(dateFrom, dateTo) {
	      var _this = this;
	
	      var dateFrom = new Date(dateFrom);
	      dateFrom = (0, _moment2.default)(dateFrom).format("YYYY-MM-DD");
	      this.dateFrom = (0, _moment2.default)(dateFrom, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss");
	
	      var dateTo = new Date(dateTo);
	      dateTo = (0, _moment2.default)(dateTo).format("YYYY-MM-DD");
	      this.dateTo = (0, _moment2.default)(dateTo, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss");
	
	      this.loading = true;
	      (0, _location.getLocationDetails)(this.locationSlug, dateFrom, dateTo).then(function (response) {
	        if (response.data.success == true) {
	          _this.locationDetails = response.data.data.locations[0];
	          _this.seatTypeOptions = response.data.data.seat_type_options;
	        }
	        _this.loading = false;
	      });
	    }
	  }
	};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _location = __webpack_require__(66);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "locationLists",
	  data: function data() {
	    return {
	      loading: false,
	      location: "",
	      locationOptions: [],
	      locationLists: [],
	      pickerOptions: {
	        disabledDate: function disabledDate(date) {
	          var dated = (0, _moment2.default)(new Date()).format("YYYY-MM-DD");
	          var comapare = (0, _moment2.default)(new Date(date)).format("YYYY-MM-DD");
	          return new Date(dated) > new Date(comapare);
	        }
	      },
	      dateFrom: (0, _moment2.default)(new Date()),
	
	      dateFromTo: []
	    };
	  },
	  mounted: function mounted() {
	    this.getLocations();
	  },
	
	  methods: {
	    getLocations: function getLocations() {
	      var _this = this;
	
	      this.loading = true;
	      (0, _location.getLocationsPulldown)().then(function (response) {
	        if (response.data.success == true) {
	          _this.locationLists = response.data.data.locations.map(function (item) {
	            return { value: item.value, label: item.label };
	          });
	        }
	        _this.loading = false;
	      });
	    },
	    remoteMethod: function remoteMethod(query) {
	      var _this2 = this;
	
	      if (query !== "") {
	        this.loading = true;
	        setTimeout(function () {
	          _this2.loading = false;
	          _this2.locationOptions = _this2.locationLists.filter(function (item) {
	            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
	          });
	        }, 200);
	      } else {
	        this.locationOptions = [];
	      }
	    },
	    handleDateClick: function handleDateClick(arg) {
	      this.dateFrom = (0, _moment2.default)(new Date(arg)).format("MM/DD/YYYY");
	    },
	    searchLocation: function searchLocation() {
	      if (this.location && this.dateFromTo) {
	        this.$router.push("/locations/" + this.location + "?date_from=" + (0, _moment2.default)(new Date(this.dateFromTo[0])).format("YYYY-MM-DD hh:mm:ss") + "&date_to=" + (0, _moment2.default)(new Date(this.dateFromTo[1])).format("YYYY-MM-DD hh:mm:ss"));
	      }
	    }
	  }
	};

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'AuthRedirect',
	  created: function created() {
	    var hash = window.location.search.slice(1);
	    window.opener.location.href = window.location.origin + '/login#' + hash;
	    window.close();
	  }
	};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(33);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _user = __webpack_require__(118);
	
	var _vueTelInput = __webpack_require__(109);
	
	var _vueTelInput2 = _interopRequireDefault(_vueTelInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultForm = {
	  phone_number: ''
	};
	var defaultLoginForm = {
	  phone_isd: '',
	  phone_number: '',
	  step: 2,
	  verification_code: ''
	};
	exports.default = {
	  name: 'Login',
	  components: {
	    VueTelInput: _vueTelInput2.default
	  },
	  data: function data() {
	    return {
	      loading: false,
	      step: 1,
	      p__errors: {},
	
	      postForm: (0, _assign2.default)({}, defaultForm),
	      rules: {
	        phone_number: {
	          'required': true,
	          'message': 'Please enter your phone number.',
	          'trigger': 'blur'
	        }
	      },
	
	      loginForm: (0, _assign2.default)({}, defaultLoginForm),
	      loginRules: {
	        verification_code: {
	          'required': true,
	          'message': 'Please enter verification code.',
	          'trigger': 'blur'
	        }
	      },
	      redirect: undefined
	    };
	  },
	
	  methods: {
	    sendVerificationCode: function sendVerificationCode() {
	      var _this = this;
	
	      this.$refs.postForm.validate(function (valid) {
	        if (valid) {
	          _this.loading = true;
	          _this.postForm.step = 1;
	          (0, _user.sendVerificationCode)(_this.postForm).then(function (response) {
	            _this.loading = false;
	            if (response.data.success === true) {
	              _this.step = 2;
	            }
	          }).catch(function () {
	            _this.loading = false;
	          });
	        } else {
	          _this.p__errors.phone_number = 'Invalid phone number.';
	          _this.validationScrollTo('#postForm');
	          return false;
	        }
	      });
	    },
	    handleLogin: function handleLogin() {
	      var _this2 = this;
	
	      this.$refs.loginForm.validate(function (valid) {
	        if (valid) {
	          _this2.loading = true;
	          _this2.loginForm.phone_isd = _this2.postForm.phone_isd;
	          _this2.loginForm.phone_number = _this2.postForm.phone_number;
	          _this2.$store.dispatch('user/LoginByPhone', _this2.loginForm).then(function () {
	            _this2.loading = false;
	            _this2.$router.push({
	              path: _this2.redirect || '/dashboard',
	              query: _this2.otherQuery
	            });
	          }).catch(function () {
	            _this2.loading = false;
	          });
	        } else {
	          _this2.p__errors.phone_number = 'Invalid phone number.';
	          _this2.validationScrollTo('#loginForm');
	          return false;
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Apps',
	  data: function data() {
	    return {
	      applePlayBtn: __webpack_require__(543),
	      googlePlayBtn: __webpack_require__(544)
	    };
	  }
	};

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'CabanaappPrivacy',
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'CabanaappTerms',
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Contact',
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Privacy',
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Terms',
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  beforeCreate: function beforeCreate() {
	    var _$route = this.$route,
	        params = _$route.params,
	        query = _$route.query;
	    var path = params.path;
	
	    this.$router.replace({ path: '/' + path, query: query });
	  },
	
	  render: function render(h) {
	    return h();
	  }
	};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reservation = __webpack_require__(44);
	
	exports.default = {
	  name: 'ReservationConfirmation',
	  data: function data() {
	    return {
	      reservationId: '',
	      paidStatus: false,
	      confirmation: ''
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.reservationId = this.$route.params.id;
	    (0, _reservation.getConfirmation)(this.reservationId).then(function (response) {
	      if (response.data.success == true) {
	        _this.confirmation = response.data.data[0];
	        _this.paidStatus = _this.confirmation.paid_status;
	      }
	      _this.loading = false;
	    });
	  },
	
	  methods: {
	    doPrint: function doPrint() {
	      window.print();
	    }
	  }
	};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(395);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(400);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(401);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(404);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(403);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _assign = __webpack_require__(33);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vueGooglemaps = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var boundProps = ['animation', 'clickable', 'cursor', 'draggable'];
	
	var redirectedEvents = ['click', 'rightclick', 'dblclick', 'drag'];
	
	exports.default = {
	  mixins: [_vueGooglemaps.MapElement],
	  props: {
	    offsetX: {
	      type: Number,
	      default: 0
	    },
	    offsetY: {
	      type: Number,
	      default: 0
	    },
	    alignment: {
	      type: String,
	      default: "top"
	    },
	    animation: {
	      type: Number
	    },
	    clickable: {
	      type: Boolean,
	      default: true
	    },
	    cursor: {
	      type: String
	    },
	    draggable: {
	      type: Boolean,
	      default: false
	    },
	    icon: {},
	    label: {},
	    opacity: {
	      type: Number,
	      default: 0.01
	    },
	    place: {
	      type: Object
	    },
	    position: {
	      type: Object
	    },
	    shape: {
	      type: Object
	    },
	    title: {
	      type: String
	    },
	    visible: {
	      default: true
	    },
	    zIndex: {
	      type: Number
	    }
	  },
	  data: function data() {
	    return {};
	  },
	  googleMapsReady: function googleMapsReady() {
	    var _this2 = this;
	
	    var options = (0, _assign2.default)({}, this.$props);
	    options.map = this.$_map;
	
	    this.$_marker = new window.google.maps.Marker(options);
	
	    this.bindProps(this.$_marker, boundProps);
	
	    this.redirectEvents(this.$_marker, redirectedEvents);
	
	    var map = this.$_map;
	    var self = this;
	
	    var Overlay = function (_google$maps$OverlayV) {
	      (0, _inherits3.default)(Overlay, _google$maps$OverlayV);
	
	      function Overlay(map) {
	        (0, _classCallCheck3.default)(this, Overlay);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).call(this));
	
	        _this.setMap(map);
	        _this.draw = function () {
	          return _this.repaint();
	        };
	        _this.setPosition = function () {
	          return _this.repaint();
	        };
	        return _this;
	      }
	
	      (0, _createClass3.default)(Overlay, [{
	        key: 'repaint',
	        value: function repaint() {
	          var div = self.$el;
	          var projection = this.getProjection();
	          if (projection && div) {
	            var posPixel = projection.fromLatLngToDivPixel(self.latLng);
	            var x = void 0,
	                y = void 0;
	            switch (self.alignment) {
	              case "top":
	                x = posPixel.x - div.offsetWidth / 2;
	                y = posPixel.y - div.offsetHeight;
	                break;
	              case "bottom":
	                x = posPixel.x - div.offsetWidth / 2;
	                y = posPixel.y;
	                break;
	              case "left":
	                x = posPixel.x - div.offsetWidth;
	                y = posPixel.y - div.offsetHeight / 2;
	                break;
	              case "right":
	                x = posPixel.x;
	                y = posPixel.y - div.offsetHeight / 2;
	                break;
	              case "center":
	                x = posPixel.x - div.offsetWidth / 2;
	                y = posPixel.y - div.offsetHeight / 2;
	                break;
	              case "topleft":
	              case "lefttop":
	                x = posPixel.x - div.offsetWidth;
	                y = posPixel.y - div.offsetHeight;
	                break;
	              case "topright":
	              case "righttop":
	                x = posPixel.x;
	                y = posPixel.y - div.offsetHeight;
	                break;
	              case "bottomleft":
	              case "leftop":
	                x = posPixel.x - div.offsetWidth;
	                y = posPixel.y;
	                break;
	              case "bottomright":
	              case "rightbottom":
	                x = posPixel.x;
	                y = posPixel.y;
	                break;
	              default:
	                throw new Error("Invalid alignment type of custom marker!");
	                break;
	            }
	            div.style.left = x + self.offsetX + "px";
	            div.style.top = y + self.offsetY + "px";
	            div.style["z-index"] = self.zIndex + 1;
	          }
	        }
	      }, {
	        key: 'onAdd',
	        value: function onAdd() {
	          var div = self.$el;
	          var panes = this.getPanes();
	          div.style.position = "absolute";
	          div.style.display = "inline-block";
	          div.style.opacity = 1;
	          panes.overlayLayer.appendChild(div);
	          panes.overlayMouseTarget.appendChild(div);
	          this.getDraggable = function () {
	            return false;
	          };
	          this.getPosition = function () {
	            return new google.maps.LatLng(self.lat, self.lng);
	          };
	        }
	      }, {
	        key: 'onRemove',
	        value: function onRemove() {
	          self.$el.remove();
	        }
	      }]);
	      return Overlay;
	    }(google.maps.OverlayView);
	
	    this.$overlay = new Overlay(map);
	    setTimeout(function () {
	      if (_this2.$overlay) {
	        _this2.$overlay.repaint();
	      }
	    }, 100);
	  },
	
	
	  computed: {
	    lat: function lat() {
	      return parseFloat(isNaN(this.$_marker.position.lat()) ? this.$_marker.position.lat() : this.$_marker.position.lat());
	    },
	    lng: function lng() {
	      return parseFloat(isNaN(this.$_marker.position.lng()) ? this.$_marker.position.lng() : this.$_marker.position.lng());
	    },
	    latLng: function latLng() {
	      if (this.$_marker instanceof google.maps.LatLng) {
	        return this.$_marker;
	      }
	      return new google.maps.LatLng(this.$_marker.position.lat(), this.$_marker.position.lng());
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    if (this.$_marker) {
	      this.$_marker.setMap(null);
	    }
	  }
	};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(402);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(33);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _location = __webpack_require__(66);
	
	var _reservation = __webpack_require__(44);
	
	var _vueStripe = __webpack_require__(614);
	
	var _vueTelInput = __webpack_require__(109);
	
	var _vueTelInput2 = _interopRequireDefault(_vueTelInput);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _gmapCustomMarker = __webpack_require__(583);
	
	var _gmapCustomMarker2 = _interopRequireDefault(_gmapCustomMarker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultForm = {
	  res_date_type: false,
	  reservation_date_single: "",
	  reservation_date: [],
	  first_name: "",
	  last_name: "",
	  phone_number: "",
	  email: "",
	  no_of_guests: "",
	  room_no: "",
	  notes: ""
	};
	
	exports.default = {
	  name: "Reservation",
	  components: {
	    VueTelInput: _vueTelInput2.default,
	    "stripe-checkout": _vueStripe.StripeCheckout,
	    "gmap-custom-marker": _gmapCustomMarker2.default
	  },
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      },
	      mapZoom: 19,
	      mapHeading: 0,
	      mapTilt: 45,
	      mapOptions: {
	        mapTypeId: "satellite",
	        zoomControl: true,
	        mapTypeControl: false,
	        scaleControl: false,
	        streetViewControl: false,
	        rotateControl: true,
	        fullscreenControl: true,
	        disableDefaultUi: false
	      },
	      markers: [],
	      selectedSeats: [],
	
	      loading: false,
	      stripeKey: location.hostname === "localhost" ? "pk_test_fc67NomR6eUQitooVAXpZrNp" : "pk_live_0nk6AdQcUZD6P68w4ud9SwAh",
	      product: {
	        name: "Reservation",
	        description: "Reservation Confirmation",
	        amount: 0
	      },
	
	      step: 1,
	      reservationId: "",
	      locationId: "",
	      locationDetails: "",
	      seatTypeOptionId: "",
	      pools: [],
	      p__errors: {},
	      postForm: (0, _assign2.default)({}, defaultForm),
	      rules: {
	        reservation_date: {
	          required: true,
	          message: "Please enter reservation date.",
	          trigger: "blur"
	        },
	        first_name: {
	          required: true,
	          message: "Please enter your first name.",
	          trigger: "blur"
	        },
	        last_name: {
	          required: true,
	          message: "Please enter your last name.",
	          trigger: "blur"
	        },
	        phone_number: {
	          required: true,
	          message: "Please enter your phone number.",
	          trigger: "blur"
	        },
	        email: {
	          required: false,
	          message: "Please enter your email.",
	          trigger: "blur"
	        }
	      },
	      dateFrom: "",
	      dateTo: "",
	      tabs: [],
	      activeTabName: "",
	      tabClosable: false,
	      editableTabsValue: "",
	      pickerOptions: {
	        disabledDate: function disabledDate(date) {
	          var dated = (0, _moment2.default)(new Date()).format("YYYY-MM-DD");
	          var comapare = (0, _moment2.default)(new Date(date)).format("YYYY-MM-DD");
	          return new Date(dated) > new Date(comapare);
	        }
	      },
	
	      locationTimezoneId: "",
	
	      tax: 0,
	      serviceFee: 0,
	      serviceFeeTaxOn: 0,
	      websiteCommissionPercent: 0,
	
	      seatAmount: 0,
	      seatAmountDisplay: "",
	      packageAmount: 0,
	      packageAmountDisplay: "",
	      serviceFeeAmount: 0,
	      serviceFeeAmountDisplay: "",
	      amount: 0,
	      amountDisplay: 0,
	      taxAmount: 0,
	      taxAmountDisplay: "",
	      commissionAmount: 0,
	      commissionAmountDisplay: ""
	    }, (0, _defineProperty3.default)(_ref, "commissionAmount", 0), (0, _defineProperty3.default)(_ref, "commissionAmountDisplay", ""), (0, _defineProperty3.default)(_ref, "depositAmount", 0), (0, _defineProperty3.default)(_ref, "depositAmountDisplay", ""), (0, _defineProperty3.default)(_ref, "dueAmount", 0), (0, _defineProperty3.default)(_ref, "dueAmountDisplay", ""), _ref;
	  },
	
	
	  watch: {
	    tabs: {
	      handler: function handler(tabs) {
	        var _this = this;
	
	        this.markers.forEach(function (m, seatIndex) {
	          _this.markers[seatIndex].selected = false;
	        });
	
	        var totalSeatPrice = 0;
	        var totalPackagePrice = 0;
	        this.tabs.forEach(function (tab, tabIndex) {
	          tab.seats.forEach(function (seat, seatIndex) {
	            seat.tax_amount = 0;
	            seat.service_fee_amount = 0;
	            if (tab.reserved.indexOf(seat.seat_no) > -1) {
	              seat.service_fee_amount = seat.seat_price * (_this.serviceFee / 100);
	              if (_this.serviceFeeTaxOn == 1) {
	                seat.tax_amount = (seat.seat_price + seat.service_fee_amount) * (_this.tax / 100);
	              } else {
	                seat.tax_amount = seat.seat_price * (_this.tax / 100);
	              }
	              totalSeatPrice = totalSeatPrice + seat.seat_price;
	
	              _this.markers[seatIndex].selected = true;
	            }
	          });
	        });
	
	        this.seatAmount = this.priceOnly(totalSeatPrice);
	        this.seatAmountDisplay = this.formatPrice(totalSeatPrice, "$");
	
	        this.packageAmount = this.priceOnly(totalPackagePrice);
	        this.packageAmountDisplay = this.formatPrice(totalPackagePrice, "$");
	
	        this.serviceFeeAmount = this.calculateReservationServiceFee(this.seatAmount + this.packageAmount, this.serviceFee);
	        this.serviceFeeAmountDisplay = this.formatPrice(this.serviceFeeAmount, "$");
	
	        this.amount = this.priceOnly(this.seatAmount + this.packageAmount + this.serviceFeeAmount);
	
	        var taxableAmount = this.serviceFeeTaxOn === 1 ? this.amount : this.amount - this.serviceFeeAmount;
	
	        this.taxAmount = this.priceOnly(taxableAmount * this.tax / 100);
	        this.taxAmountDisplay = this.formatPrice(this.taxAmount, "$");
	
	        this.amount = this.priceOnly(this.amount + this.taxAmount);
	        this.amountDisplay = this.formatPrice(this.amount, "$");
	
	        this.depositAmount = this.calculateReservationCommissionAmount(totalSeatPrice, this.reservationCommission, this.reservationCommissionType);
	        this.product.amount = this.depositAmount * 100;
	        this.depositAmountDisplay = this.formatPrice(this.depositAmount, "$");
	
	        this.dueAmount = this.priceOnly(this.amount) - this.priceOnly(this.depositAmount);
	        this.dueAmountDisplay = this.formatPrice(this.dueAmount, "$");
	      },
	
	      deep: true
	    }
	  },
	
	  created: function created() {
	    var _this2 = this;
	
	    this.loading = true;
	    this.dateFrom = this.$route.query.date_from;
	    this.dateTo = this.$route.query.date_to;
	    this.locationSlug = this.$route.params.slug;
	    this.seatTypeOptionId = this.$route.query.seat_type_option_id;
	
	    if (this.dateFrom) {
	      this.dateFrom = (0, _moment2.default)(this.dateFrom, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss");
	    }
	
	    if (this.dateTo) {
	      this.dateTo = (0, _moment2.default)(this.dateTo, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss");
	    }
	
	    this.postForm.reservation_date = [(0, _moment2.default)(this.dateFrom).format("YYYY-MM-DD hh:mm:ss"), (0, _moment2.default)(this.dateTo).format("YYYY-MM-DD hh:mm:ss")];
	
	    (0, _location.getLocationDetails)(this.locationSlug, this.dateFrom, this.dateTo).then(function (response) {
	      if (response.data.success == true) {
	        _this2.locationDetails = response.data.data.locations[0];
	        _this2.pools = response.data.data.pools;
	        _this2.locationId = _this2.locationDetails.id;
	        _this2.tax = _this2.locationDetails.tax;
	        _this2.serviceFee = _this2.locationDetails.service_fee;
	        _this2.serviceFeeTaxOn = _this2.locationDetails.service_fee_tax_on;
	        _this2.websiteCommissionPercent = _this2.locationDetails.website_commission_percent;
	        _this2.reservationCommission = _this2.locationDetails.reservation_commission;
	        _this2.reservationCommissionType = _this2.locationDetails.reservation_commission_type;
	        _this2.locationTimezoneId = _this2.locationDetails.timezone_id;
	        _this2.initMapMarker();
	        _this2.onMultiDatePick([_this2.dateFrom, _this2.dateTo]);
	      }
	      _this2.loading = false;
	    });
	
	    _vueStripe.Bus.$on("vue-stripe.success", function (payload) {
	      _this2.loading = true;
	      var tokenId = payload.token;
	
	      _this2.postForm = {};
	      _this2.postForm.reservation_id = _this2.reservationId;
	      _this2.postForm.token_id = tokenId;
	      _this2.postForm.payment_mode = "card";
	      _this2.postForm.currency = "usd";
	      _this2.postForm.deposit_amount = _this2.depositAmount;
	
	      (0, _reservation.confirmReservation)(_this2.postForm).then(function (response) {
	        if (response.data.success === true) {
	          _this2.$router.push("/reservations/confirmation/" + _this2.reservationId);
	        } else {
	          _this2.validationErrors(response.data.message);
	        }
	        _this2.loading = false;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    });
	  },
	
	  methods: {
	    handleChangeResDateType: function handleChangeResDateType(arg) {
	      if (arg == true) {
	        this.onSingleDatePick(this.postForm.reservation_date_single);
	      } else {
	        this.onMultiDatePick(this.postForm.reservation_date);
	      }
	    },
	    initMapMarker: function initMapMarker() {
	      var latLng = {
	        lat: parseFloat(this.locationDetails.latitude),
	        lng: parseFloat(this.locationDetails.longitude)
	      };
	      this.mapCenter = latLng;
	    },
	    showMapMarkers: function showMapMarkers(seats) {
	      var _this3 = this;
	
	      if (seats) {
	        var map = this.$refs.map.$_map;
	
	        var bounds = new window.google.maps.LatLngBounds();
	
	        this.mapHeading = 270;
	        this.mapTilt = 45;
	        seats.forEach(function (seat, seatIndex) {
	          if (seat.seat_latitude && seat.seat_longitude) {
	            var latLng = {
	              lat: parseFloat(seat.seat_latitude),
	              lng: parseFloat(seat.seat_longitude)
	            };
	
	            _this3.markers.push({
	              position: latLng,
	              seat_no: seat.seat_no,
	              tooltip: seat.seat_label + " " + seat.seat_no + " | " + seat.seat_price_display,
	              booked: seat.booked,
	              selected: false
	            });
	            bounds.extend(latLng);
	          }
	        });
	        setTimeout(function () {
	          map.fitBounds(bounds);
	        }, 100);
	      }
	    },
	    mapMarkerClass: function mapMarkerClass(m) {
	      if (!m.booked && !m.selected) {
	        return "default-color";
	      } else if (m.booked && !m.checked_in) {
	        return "default-color booked";
	      } else if (m.booked && m.checked_in && m.reservation_date_id) {
	        return "default-color booked";
	      } else if (m.selected) {
	        return "default-color selected";
	      }
	    },
	    mapMarkerClick: function mapMarkerClick(m) {
	      var _this4 = this;
	
	      m.selected = !m.selected;
	
	      this.tabs.forEach(function (tab, tabIndex) {
	        if (m.selected) {
	          tab.reserved.push(m.seat_no);
	        } else {
	          var index = tab.reserved.indexOf(m.seat_no);
	          if (index > -1) {
	            tab.reserved.splice(index, 1);
	          }
	        }
	        _this4.selectedSeats = tab.reserved;
	      });
	    },
	    handleRemoveSeat: function handleRemoveSeat(seatNo) {
	      var _this5 = this;
	
	      this.$confirm('Are you sure, want to remove?', 'Warning', {
	        confirmButtonText: 'Yes',
	        cancelButtonText: 'No',
	        type: 'warning'
	      }).then(function () {
	        _this5.tabs.forEach(function (tab, tabIndex) {
	          var index = tab.reserved.indexOf(seatNo);
	          if (index > -1) {
	            tab.reserved.splice(index, 1);
	          }
	          _this5.selectedSeats = tab.reserved;
	        });
	      }).catch(function () {});
	    },
	    handleMarkerSelected: function handleMarkerSelected(isBack) {
	      if (isBack) {
	        this.$router.push("/locations/" + this.locationSlug + "?" + "&date_from=" + (0, _moment2.default)(this.dateFrom, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss") + "&date_to=" + (0, _moment2.default)(this.dateTo, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss"));
	      } else {
	        this.step = 3;
	      }
	    },
	    handleSeatSelected: function handleSeatSelected(isBack) {
	      if (isBack) {
	        this.step = 1;
	      } else {
	        this.step = 3;
	      }
	    },
	    submitForm: function submitForm(isBack) {
	      var _this6 = this;
	
	      if (isBack) {
	        this.step = 1;
	      } else {
	        this.loading = true;
	        this.$refs.postForm.validate(function (valid) {
	          if (valid) {
	            _this6.postForm.date_from = _this6.dateFrom;
	            _this6.postForm.date_to = _this6.dateTo;
	            _this6.postForm.location_id = _this6.locationId;
	            _this6.postForm.tabs = _this6.tabs;
	            _this6.postForm.service_fee_amount = _this6.serviceFeeAmount;
	            _this6.postForm.deposit_amount = _this6.depositAmount;
	            _this6.postForm.timezone_id = _this6.locationTimezoneId;
	
	            (0, _reservation.store)(_this6.postForm).then(function (response) {
	              if (response.data.success === true) {
	                _this6.reservationId = response.data.data.id;
	                if (_this6.depositAmount > 0) {
	                  _this6.$refs.stripeCheckoutRef.purchase();
	                } else {
	                  (0, _reservation.sendConfirmReservationEmail)(response.data.data.id).then(function (response) {}).catch(function (err) {
	                    console.log(err);
	                  });
	                  _this6.$router.push("/reservations/confirmation/" + response.data.data.id);
	                }
	              } else {
	                _this6.validationErrors(response.data.message);
	              }
	              _this6.loading = false;
	            }).catch(function (err) {
	              console.log(err);
	            });
	          } else {
	            _this6.loading = false;
	            _this6.validationScrollTo("#postForm");
	            return false;
	          }
	        });
	      }
	    },
	    addTab: function addTab(tab) {
	      this.tabs.push({
	        title: tab.date,
	        name: tab.date,
	        seats: tab.seats,
	        reserved: [],
	        from_date_time: tab.from_date_time,
	        to_date_time: tab.to_date_time,
	        content: "New Tab content"
	      });
	      this.editableTabsValue = tab.date;
	    },
	    tabClick: function tabClick(tab) {
	      var tabId = tab.name;
	      this.activeTabName = tabId;
	    },
	    tabRemove: function tabRemove(val) {
	      console.log(val);
	    },
	    generateRequestData: function generateRequestData(formsData) {
	      var _this7 = this;
	
	      var data = {};
	      _.each(formsData, function (element, index) {
	        if (_this7.postForm.hasOwnProperty(index) && index === "link" && element !== "") {
	          data[index] = "http://" + element;
	        } else {
	          data[index] = element;
	        }
	      });
	      return data;
	    },
	    onSingleDatePick: function onSingleDatePick(date) {
	      this.postForm.reservation_date = [(0, _moment2.default)(date).format("YYYY-MM-DD hh:mm:ss"), (0, _moment2.default)(date).format("YYYY-MM-DD hh:mm:ss")];
	      this.onMultiDatePick([date, date]);
	    },
	    onMultiDatePick: function onMultiDatePick(range) {
	      var _this8 = this;
	
	      this.loading = true;
	      this.tabs = [];
	      var firstRange = (0, _moment2.default)(range[0]);
	      var lastRange = (0, _moment2.default)(range[1]);
	      var diffInDay = lastRange.diff(firstRange, 'days') + 1;
	      var dates = [];
	      if (diffInDay > 0) {
	        for (var i = 0; i < diffInDay; i++) {
	          var today = (0, _moment2.default)(firstRange).add(i, 'days');
	          var formatedDate = today.format('YYYY-MM-DD');
	          dates.push(formatedDate);
	        }
	      }
	      var locationId = this.locationId;
	      this.loading = false;
	      (0, _reservation.getAvailableSeats)(locationId, dates, this.locationTimezoneId, this.seatTypeOptionId).then(function (response) {
	        var tabs = response.data.data.seats;
	        tabs.forEach(function (item, index) {
	          _this8.addTab(item);
	        });
	        _this8.activeTabName = tabs[0].date;
	        _this8.editableTabsValue = _this8.activeTabName;
	
	        _this8.showMapMarkers(tabs[0].seats);
	        _this8.loading = false;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }
	};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reservation = __webpack_require__(44);
	
	exports.default = {
	  name: 'ReservationSuccess',
	  data: function data() {
	    return {
	      loading: false,
	      reservationId: '',
	      confirmation: ''
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    this.reservationId = this.$route.params.id;
	    (0, _reservation.getConfirmation)(this.reservationId).then(function (response) {
	      if (response.data.success == true) {
	        _this.confirmation = response.data.data[0];
	      }
	      _this.loading = false;
	    });
	  }
	};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = store;
	
	var _request = __webpack_require__(32);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function store(data) {
	  return (0, _request2.default)({
	    url: 'hotel-partners/create',
	    method: 'post',
	    data: data
	  });
	}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSettings = getSettings;
	
	var _request = __webpack_require__(32);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSettings() {
	  return (0, _request2.default)({
	    url: 'guest/settings',
	    method: 'get'
	  });
	}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(390);
	
	Object.defineProperty(exports, 'parseTime', {
	  enumerable: true,
	  get: function get() {
	    return _utils.parseTime;
	  }
	});
	Object.defineProperty(exports, 'formatTime', {
	  enumerable: true,
	  get: function get() {
	    return _utils.formatTime;
	  }
	});
	exports.timeAgo = timeAgo;
	exports.numberFormatter = numberFormatter;
	exports.toThousandFilter = toThousandFilter;
	exports.yearFilter = yearFilter;
	
	
	function pluralize(time, label) {
	  if (time === 1) {
	    return time + label;
	  }
	  return time + label + 's';
	}
	
	function timeAgo(time) {
	  var between = Date.now() / 1000 - Number(time);
	  if (between < 3600) {
	    return pluralize(~~(between / 60), ' minute');
	  } else if (between < 86400) {
	    return pluralize(~~(between / 3600), ' hour');
	  } else {
	    return pluralize(~~(between / 86400), ' day');
	  }
	}
	
	function numberFormatter(num, digits) {
	  var si = [{ value: 1E18, symbol: 'E' }, { value: 1E15, symbol: 'P' }, { value: 1E12, symbol: 'T' }, { value: 1E9, symbol: 'G' }, { value: 1E6, symbol: 'M' }, { value: 1E3, symbol: 'k' }];
	  for (var i = 0; i < si.length; i++) {
	    if (num >= si[i].value) {
	      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
	    }
	  }
	  return num.toString();
	}
	
	function toThousandFilter(num) {
	  return (+num || 0).toString().replace(/^-?\d+/g, function (m) {
	    return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
	  });
	}
	
	function yearFilter(date) {
	  return moment(date).format('YYYY');
	}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(122);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(29);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _asyncToGenerator2 = __webpack_require__(121);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _router = __webpack_require__(45);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(46);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _elementUi = __webpack_require__(87);
	
	var _nprogress = __webpack_require__(535);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	__webpack_require__(481);
	
	var _auth = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_nprogress2.default.configure({ showSpinner: false });
	
	var whiteList = ['/login', '/auth-redirect'];
	
	_router2.default.beforeEach(function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(to, from, next) {
	    var hasToken, hasRoles, _ref2, roles;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _nprogress2.default.start();
	
	            hasToken = (0, _auth.getToken)();
	
	            if (!hasToken) {
	              _context.next = 30;
	              break;
	            }
	
	            if (!(to.path === '/login')) {
	              _context.next = 8;
	              break;
	            }
	
	            next({ path: '/' });
	            _nprogress2.default.done();
	            _context.next = 28;
	            break;
	
	          case 8:
	            hasRoles = _store2.default.getters.roles && _store2.default.getters.roles.length > 0;
	
	            if (!hasRoles) {
	              _context.next = 13;
	              break;
	            }
	
	            next();
	            _context.next = 28;
	            break;
	
	          case 13:
	            _context.prev = 13;
	            _context.next = 16;
	            return _store2.default.dispatch('user/GetUserInfo');
	
	          case 16:
	            _ref2 = _context.sent;
	            roles = _ref2.roles;
	
	            next((0, _extends3.default)({}, to, { replace: true }));
	            _context.next = 28;
	            break;
	
	          case 21:
	            _context.prev = 21;
	            _context.t0 = _context['catch'](13);
	            _context.next = 25;
	            return _store2.default.dispatch('user/resetToken');
	
	          case 25:
	            _elementUi.Message.error(_context.t0 || 'Has Error');
	            next('/login?redirect=' + to.path);
	            _nprogress2.default.done();
	
	          case 28:
	            _context.next = 31;
	            break;
	
	          case 30:
	            next();
	
	          case 31:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[13, 21]]);
	  }));
	
	  return function (_x, _x2, _x3) {
	    return _ref.apply(this, arguments);
	  };
	}());
	
	_router2.default.afterEach(function () {
	  _nprogress2.default.done();
	});

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getters = {
	  sidebar: function sidebar(state) {
	    return state.app.sidebar;
	  },
	  size: function size(state) {
	    return state.app.size;
	  },
	  device: function device(state) {
	    return state.app.device;
	  },
	  visitedViews: function visitedViews(state) {
	    return state.tagsView.visitedViews;
	  },
	  cachedViews: function cachedViews(state) {
	    return state.tagsView.cachedViews;
	  },
	  token: function token(state) {
	    return state.user.token;
	  },
	  avatar: function avatar(state) {
	    return state.user.avatar;
	  },
	  user_id: function user_id(state) {
	    return state.user.user_id;
	  },
	  name: function name(state) {
	    return state.user.name;
	  },
	  roles: function roles(state) {
	    return state.user.roles;
	  },
	  permission_routes: function permission_routes(state) {
	    return state.permission.routes;
	  },
	  errorLogs: function errorLogs(state) {
	    return state.errorLog.logs;
	  }
	};
	exports.default = getters;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsCookie = __webpack_require__(97);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = {
	  state: {
	    sidebar: {
	      opened: !+_jsCookie2.default.get('sidebarStatus'),
	      withoutAnimation: false
	    },
	    device: 'desktop',
	    language: _jsCookie2.default.get('language') || 'en',
	    size: _jsCookie2.default.get('size') || 'medium'
	  },
	  mutations: {
	    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
	      if (state.sidebar.opened) {
	        _jsCookie2.default.set('sidebarStatus', 1);
	      } else {
	        _jsCookie2.default.set('sidebarStatus', 0);
	      }
	      state.sidebar.opened = !state.sidebar.opened;
	      state.sidebar.withoutAnimation = false;
	    },
	    CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
	      _jsCookie2.default.set('sidebarStatus', 1);
	      state.sidebar.opened = false;
	      state.sidebar.withoutAnimation = withoutAnimation;
	    },
	    TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
	      state.device = device;
	    },
	    SET_LANGUAGE: function SET_LANGUAGE(state, language) {
	      state.language = language;
	      _jsCookie2.default.set('language', language);
	    },
	    SET_SIZE: function SET_SIZE(state, size) {
	      state.size = size;
	      _jsCookie2.default.set('size', size);
	    }
	  },
	  actions: {
	    toggleSideBar: function toggleSideBar(_ref) {
	      var commit = _ref.commit;
	
	      commit('TOGGLE_SIDEBAR');
	    },
	    closeSideBar: function closeSideBar(_ref2, _ref3) {
	      var commit = _ref2.commit;
	      var withoutAnimation = _ref3.withoutAnimation;
	
	      commit('CLOSE_SIDEBAR', withoutAnimation);
	    },
	    toggleDevice: function toggleDevice(_ref4, device) {
	      var commit = _ref4.commit;
	
	      commit('TOGGLE_DEVICE', device);
	    },
	    setLanguage: function setLanguage(_ref5, language) {
	      var commit = _ref5.commit;
	
	      commit('SET_LANGUAGE', language);
	    },
	    setSize: function setSize(_ref6, size) {
	      var commit = _ref6.commit;
	
	      commit('SET_SIZE', size);
	    }
	  }
	};
	
	exports.default = app;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(47);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(29);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.filterAsyncRoutes = filterAsyncRoutes;
	
	var _router = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasPermission(roles, route) {
	  if (route.meta && route.meta.roles) {
	    return roles.some(function (role) {
	      return route.meta.roles.includes(role);
	    });
	  } else {
	    return true;
	  }
	}
	
	function filterAsyncRoutes(routes, roles) {
	  var res = [];
	
	  routes.forEach(function (route) {
	    var tmp = (0, _extends3.default)({}, route);
	    if (hasPermission(roles, tmp)) {
	      if (tmp.children) {
	        tmp.children = filterAsyncRoutes(tmp.children, roles);
	      }
	      res.push(tmp);
	    }
	  });
	
	  return res;
	}
	
	var state = {
	  routes: [],
	  addRoutes: []
	};
	
	var mutations = {
	  SET_ROUTES: function SET_ROUTES(state, routes) {
	    state.addRoutes = routes;
	    state.routes = _router.constantRoutes.concat(routes);
	  }
	};
	
	var actions = {
	  generateRoutes: function generateRoutes(_ref, roles) {
	    var commit = _ref.commit;
	
	    return new _promise2.default(function (resolve) {
	      var accessedRoutes = void 0;
	      if (roles.includes('admin')) {
	        accessedRoutes = _router.asyncRoutes || [];
	      } else {
	        accessedRoutes = filterAsyncRoutes(_router.asyncRoutes, roles);
	      }
	      commit('SET_ROUTES', accessedRoutes);
	      resolve(accessedRoutes);
	    });
	  }
	};
	
	exports.default = {
	  namespaced: true,
	  state: state,
	  mutations: mutations,
	  actions: actions
	};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(122);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(121);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(47);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _user = __webpack_require__(118);
	
	var _auth = __webpack_require__(67);
	
	var _router = __webpack_require__(45);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  token: (0, _auth.getToken)(),
	  user_id: '',
	  name: '',
	  avatar: '',
	  introduction: '',
	  roles: []
	};
	
	var mutations = {
	  SET_TOKEN: function SET_TOKEN(state, token) {
	    state.token = token;
	  },
	  SET_USER_ID: function SET_USER_ID(state, user_id) {
	    state.user_id = user_id;
	  },
	  SET_NAME: function SET_NAME(state, name) {
	    state.name = name;
	  },
	  SET_AVATAR: function SET_AVATAR(state, avatar) {
	    state.avatar = avatar;
	  },
	  SET_ROLES: function SET_ROLES(state, roles) {
	    state.roles = roles;
	  }
	};
	
	var actions = {
	  LoginByPhone: function LoginByPhone(_ref, userInfo) {
	    var commit = _ref.commit;
	    var phone_isd = userInfo.phone_isd,
	        phone_number = userInfo.phone_number,
	        step = userInfo.step,
	        verification_code = userInfo.verification_code;
	
	    return new _promise2.default(function (resolve, reject) {
	      (0, _user.loginByPhone)({ phone_isd: phone_isd.trim(), phone_number: phone_number.trim(), step: step, verification_code: verification_code }).then(function (response) {
	        var data = response.data.data;
	
	        commit('SET_TOKEN', data.access_token);
	        (0, _auth.setToken)(data.access_token);
	        resolve();
	      }).catch(function (error) {
	        reject(error);
	      });
	    });
	  },
	  GetUserInfo: function GetUserInfo(_ref2) {
	    var commit = _ref2.commit,
	        state = _ref2.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      (0, _user.getUserInfo)(state.token).then(function (response) {
	        var data = response.data.data;
	
	
	        if (!data) {
	          reject('Verification failed, please Login again.');
	        }
	
	        var roles = data.roles,
	            user_id = data.user_id,
	            name = data.name,
	            avatar = data.avatar;
	
	        if (!roles || roles.length <= 0) {
	          reject('getInfo: roles must be a non-null array!');
	        }
	
	        commit('SET_ROLES', roles);
	        commit('SET_USER_ID', user_id);
	        commit('SET_NAME', name);
	        commit('SET_AVATAR', avatar);
	        resolve(data);
	      }).catch(function (error) {
	        reject(error);
	      });
	    });
	  },
	  Logout: function Logout(_ref3) {
	    var commit = _ref3.commit,
	        state = _ref3.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      (0, _user.logout)(state.token).then(function () {
	        commit('SET_TOKEN', '');
	        commit('SET_ROLES', []);
	        (0, _auth.removeToken)();
	
	        resolve();
	      }).catch(function (error) {
	        reject(error);
	      });
	    });
	  },
	  resetToken: function resetToken(_ref4) {
	    var commit = _ref4.commit;
	
	    return new _promise2.default(function (resolve) {
	      commit('SET_TOKEN', '');
	      commit('SET_ROLES', []);
	      (0, _auth.removeToken)();
	      resolve();
	    });
	  },
	  changeRoles: function changeRoles(_ref5, role) {
	    var _this = this;
	
	    var commit = _ref5.commit,
	        dispatch = _ref5.dispatch;
	
	    return new _promise2.default(function () {
	      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(resolve) {
	        var token, _ref7, roles, accessRoutes;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                token = role + '-token';
	
	
	                commit('SET_TOKEN', token);
	                (0, _auth.setToken)(token);
	
	                _context.next = 5;
	                return dispatch('getInfo');
	
	              case 5:
	                _ref7 = _context.sent;
	                roles = _ref7.roles;
	
	
	                (0, _router.resetRouter)();
	
	                _context.next = 10;
	                return dispatch('permission/generateRoutes', roles, { root: true });
	
	              case 10:
	                accessRoutes = _context.sent;
	
	                _router2.default.addRoutes(accessRoutes);
	
	                dispatch('tagsView/delAllViews', null, { root: true });
	
	                resolve();
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref6.apply(this, arguments);
	      };
	    }());
	  }
	};
	
	exports.default = {
	  namespaced: true,
	  state: state,
	  mutations: mutations,
	  actions: actions
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pickerOptions = undefined;
	
	var _set = __webpack_require__(397);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(393);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _keys = __webpack_require__(120);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(22);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.parseTime = parseTime;
	exports.formatTime = formatTime;
	exports.getQueryObject = getQueryObject;
	exports.getByteLen = getByteLen;
	exports.cleanArray = cleanArray;
	exports.param = param;
	exports.param2Obj = param2Obj;
	exports.html2Text = html2Text;
	exports.objectMerge = objectMerge;
	exports.toggleClass = toggleClass;
	exports.getTime = getTime;
	exports.debounce = debounce;
	exports.deepClone = deepClone;
	exports.uniqueArr = uniqueArr;
	exports.isExternal = isExternal;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseTime(time, cFormat) {
	  if (arguments.length === 0) {
	    return null;
	  }
	  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
	  var date = void 0;
	  if ((typeof time === 'undefined' ? 'undefined' : (0, _typeof3.default)(time)) === 'object') {
	    date = time;
	  } else {
	    if (('' + time).length === 10) time = parseInt(time) * 1000;
	    date = new Date(time);
	  }
	  var formatObj = {
	    y: date.getFullYear(),
	    m: date.getMonth() + 1,
	    d: date.getDate(),
	    h: date.getHours(),
	    i: date.getMinutes(),
	    s: date.getSeconds(),
	    a: date.getDay()
	  };
	  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
	    var value = formatObj[key];
	
	    if (key === 'a') {
	      return ['day', 'One', 'two', 'three', 'four', 'Fives', 'six'][value];
	    }
	    if (result.length > 0 && value < 10) {
	      value = '0' + value;
	    }
	    return value || 0;
	  });
	  return time_str;
	}
	
	function formatTime(time, option) {
	  time = +time * 1000;
	  var d = new Date(time);
	  var now = Date.now();
	
	  var diff = (now - d) / 1000;
	
	  if (diff < 30) {
	    return 'just';
	  } else if (diff < 3600) {
	    return Math.ceil(diff / 60) + 'minutes ago';
	  } else if (diff < 3600 * 24) {
	    return Math.ceil(diff / 3600) + 'An hour ago';
	  } else if (diff < 3600 * 24 * 2) {
	    return '1 day ago';
	  }
	  if (option) {
	    return parseTime(time, option);
	  } else {
	    return d.getMonth() + 1 + 'month' + d.getDate() + 'day' + d.getHours() + 'Time' + d.getMinutes() + 'Minute';
	  }
	}
	
	function getQueryObject(url) {
	  url = url == null ? window.location.href : url;
	  var search = url.substring(url.lastIndexOf('?') + 1);
	  var obj = {};
	  var reg = /([^?&=]+)=([^?&=]*)/g;
	  search.replace(reg, function (rs, $1, $2) {
	    var name = decodeURIComponent($1);
	    var val = decodeURIComponent($2);
	    val = String(val);
	    obj[name] = val;
	    return rs;
	  });
	  return obj;
	}
	
	function getByteLen(val) {
	  var len = 0;
	  for (var i = 0; i < val.length; i++) {
	    if (val[i].match(/[^\x00-\xff]/gi) != null) {
	      len += 1;
	    } else {
	      len += 0.5;
	    }
	  }
	  return Math.floor(len);
	}
	
	function cleanArray(actual) {
	  var newArray = [];
	  for (var i = 0; i < actual.length; i++) {
	    if (actual[i]) {
	      newArray.push(actual[i]);
	    }
	  }
	  return newArray;
	}
	
	function param(json) {
	  if (!json) return '';
	  return cleanArray((0, _keys2.default)(json).map(function (key) {
	    if (json[key] === undefined) return '';
	    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
	  })).join('&');
	}
	
	function param2Obj(url) {
	  var search = url.split('?')[1];
	  if (!search) {
	    return {};
	  }
	  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
	}
	
	function html2Text(val) {
	  var div = document.createElement('div');
	  div.innerHTML = val;
	  return div.textContent || div.innerText;
	}
	
	function objectMerge(target, source) {
	
	  if ((typeof target === 'undefined' ? 'undefined' : (0, _typeof3.default)(target)) !== 'object') {
	    target = {};
	  }
	  if (Array.isArray(source)) {
	    return source.slice();
	  }
	  (0, _keys2.default)(source).forEach(function (property) {
	    var sourceProperty = source[property];
	    if ((typeof sourceProperty === 'undefined' ? 'undefined' : (0, _typeof3.default)(sourceProperty)) === 'object') {
	      target[property] = objectMerge(target[property], sourceProperty);
	    } else {
	      target[property] = sourceProperty;
	    }
	  });
	  return target;
	}
	
	function toggleClass(element, className) {
	  if (!element || !className) {
	    return;
	  }
	  var classString = element.className;
	  var nameIndex = classString.indexOf(className);
	  if (nameIndex === -1) {
	    classString += '' + className;
	  } else {
	    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
	  }
	  element.className = classString;
	}
	
	var pickerOptions = exports.pickerOptions = [{
	  text: 'Nowadays',
	  onClick: function onClick(picker) {
	    var end = new Date();
	    var start = new Date(new Date().toDateString());
	    end.setTime(start.getTime());
	    picker.$emit('pick', [start, end]);
	  }
	}, {
	  text: 'Last week',
	  onClick: function onClick(picker) {
	    var end = new Date(new Date().toDateString());
	    var start = new Date();
	    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
	    picker.$emit('pick', [start, end]);
	  }
	}, {
	  text: 'Last month',
	  onClick: function onClick(picker) {
	    var end = new Date(new Date().toDateString());
	    var start = new Date();
	    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
	    picker.$emit('pick', [start, end]);
	  }
	}, {
	  text: 'Last three months',
	  onClick: function onClick(picker) {
	    var end = new Date(new Date().toDateString());
	    var start = new Date();
	    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
	    picker.$emit('pick', [start, end]);
	  }
	}];
	
	function getTime(type) {
	  if (type === 'start') {
	    return new Date().getTime() - 3600 * 1000 * 24 * 90;
	  } else {
	    return new Date(new Date().toDateString());
	  }
	}
	
	function debounce(func, wait, immediate) {
	  var timeout = void 0,
	      args = void 0,
	      context = void 0,
	      timestamp = void 0,
	      result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last > 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      }
	    }
	  };
	
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    context = this;
	    timestamp = +new Date();
	    var callNow = immediate && !timeout;
	
	    if (!timeout) timeout = setTimeout(later, wait);
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	
	    return result;
	  };
	}
	
	function deepClone(source) {
	  if (!source && (typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) !== 'object') {
	    throw new Error('error arguments', 'shallowClone');
	  }
	  var targetObj = source.constructor === Array ? [] : {};
	  (0, _keys2.default)(source).forEach(function (keys) {
	    if (source[keys] && (0, _typeof3.default)(source[keys]) === 'object') {
	      targetObj[keys] = deepClone(source[keys]);
	    } else {
	      targetObj[keys] = source[keys];
	    }
	  });
	  return targetObj;
	}
	
	function uniqueArr(arr) {
	  return (0, _from2.default)(new _set2.default(arr));
	}
	
	function isExternal(path) {
	  return (/^(https?:|mailto:|tel:)/.test(path)
	  );
	}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sidebar = __webpack_require__(570);
	
	Object.defineProperty(exports, 'Sidebar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sidebar).default;
	  }
	});
	
	var _Navbar = __webpack_require__(569);
	
	Object.defineProperty(exports, 'Navbar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Navbar).default;
	  }
	});
	
	var _AppMain = __webpack_require__(567);
	
	Object.defineProperty(exports, 'AppMain', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AppMain).default;
	  }
	});
	
	var _AppFooter = __webpack_require__(566);
	
	Object.defineProperty(exports, 'AppFooter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AppFooter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(46);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _document = document,
	    body = _document.body;
	
	var WIDTH = 1024;
	var RATIO = 3;
	
	exports.default = {
	  beforeMount: function beforeMount() {
	    window.addEventListener('resize', this.resizeHandler);
	  },
	  mounted: function mounted() {
	    var isMobile = this.isMobile();
	    if (isMobile) {
	      _store2.default.dispatch('toggleDevice', 'mobile');
	    }
	  },
	
	  methods: {
	    isMobile: function isMobile() {
	      var rect = body.getBoundingClientRect();
	      return rect.width - RATIO < WIDTH;
	    },
	    resizeHandler: function resizeHandler() {
	      if (!document.hidden) {
	        var isMobile = this.isMobile();
	        _store2.default.dispatch('toggleDevice', isMobile ? 'mobile' : 'desktop');
	      }
	    }
	  }
	};

/***/ }),
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 172,
		"./af.js": 172,
		"./ar": 179,
		"./ar-dz": 173,
		"./ar-dz.js": 173,
		"./ar-kw": 174,
		"./ar-kw.js": 174,
		"./ar-ly": 175,
		"./ar-ly.js": 175,
		"./ar-ma": 176,
		"./ar-ma.js": 176,
		"./ar-sa": 177,
		"./ar-sa.js": 177,
		"./ar-tn": 178,
		"./ar-tn.js": 178,
		"./ar.js": 179,
		"./az": 180,
		"./az.js": 180,
		"./be": 181,
		"./be.js": 181,
		"./bg": 182,
		"./bg.js": 182,
		"./bm": 183,
		"./bm.js": 183,
		"./bn": 185,
		"./bn-bd": 184,
		"./bn-bd.js": 184,
		"./bn.js": 185,
		"./bo": 186,
		"./bo.js": 186,
		"./br": 187,
		"./br.js": 187,
		"./bs": 188,
		"./bs.js": 188,
		"./ca": 189,
		"./ca.js": 189,
		"./cs": 190,
		"./cs.js": 190,
		"./cv": 191,
		"./cv.js": 191,
		"./cy": 192,
		"./cy.js": 192,
		"./da": 193,
		"./da.js": 193,
		"./de": 196,
		"./de-at": 194,
		"./de-at.js": 194,
		"./de-ch": 195,
		"./de-ch.js": 195,
		"./de.js": 196,
		"./dv": 197,
		"./dv.js": 197,
		"./el": 198,
		"./el.js": 198,
		"./en-au": 199,
		"./en-au.js": 199,
		"./en-ca": 200,
		"./en-ca.js": 200,
		"./en-gb": 201,
		"./en-gb.js": 201,
		"./en-ie": 202,
		"./en-ie.js": 202,
		"./en-il": 203,
		"./en-il.js": 203,
		"./en-in": 204,
		"./en-in.js": 204,
		"./en-nz": 205,
		"./en-nz.js": 205,
		"./en-sg": 206,
		"./en-sg.js": 206,
		"./eo": 207,
		"./eo.js": 207,
		"./es": 211,
		"./es-do": 208,
		"./es-do.js": 208,
		"./es-mx": 209,
		"./es-mx.js": 209,
		"./es-us": 210,
		"./es-us.js": 210,
		"./es.js": 211,
		"./et": 212,
		"./et.js": 212,
		"./eu": 213,
		"./eu.js": 213,
		"./fa": 214,
		"./fa.js": 214,
		"./fi": 215,
		"./fi.js": 215,
		"./fil": 216,
		"./fil.js": 216,
		"./fo": 217,
		"./fo.js": 217,
		"./fr": 220,
		"./fr-ca": 218,
		"./fr-ca.js": 218,
		"./fr-ch": 219,
		"./fr-ch.js": 219,
		"./fr.js": 220,
		"./fy": 221,
		"./fy.js": 221,
		"./ga": 222,
		"./ga.js": 222,
		"./gd": 223,
		"./gd.js": 223,
		"./gl": 224,
		"./gl.js": 224,
		"./gom-deva": 225,
		"./gom-deva.js": 225,
		"./gom-latn": 226,
		"./gom-latn.js": 226,
		"./gu": 227,
		"./gu.js": 227,
		"./he": 228,
		"./he.js": 228,
		"./hi": 229,
		"./hi.js": 229,
		"./hr": 230,
		"./hr.js": 230,
		"./hu": 231,
		"./hu.js": 231,
		"./hy-am": 232,
		"./hy-am.js": 232,
		"./id": 233,
		"./id.js": 233,
		"./is": 234,
		"./is.js": 234,
		"./it": 236,
		"./it-ch": 235,
		"./it-ch.js": 235,
		"./it.js": 236,
		"./ja": 237,
		"./ja.js": 237,
		"./jv": 238,
		"./jv.js": 238,
		"./ka": 239,
		"./ka.js": 239,
		"./kk": 240,
		"./kk.js": 240,
		"./km": 241,
		"./km.js": 241,
		"./kn": 242,
		"./kn.js": 242,
		"./ko": 243,
		"./ko.js": 243,
		"./ku": 244,
		"./ku.js": 244,
		"./ky": 245,
		"./ky.js": 245,
		"./lb": 246,
		"./lb.js": 246,
		"./lo": 247,
		"./lo.js": 247,
		"./lt": 248,
		"./lt.js": 248,
		"./lv": 249,
		"./lv.js": 249,
		"./me": 250,
		"./me.js": 250,
		"./mi": 251,
		"./mi.js": 251,
		"./mk": 252,
		"./mk.js": 252,
		"./ml": 253,
		"./ml.js": 253,
		"./mn": 254,
		"./mn.js": 254,
		"./mr": 255,
		"./mr.js": 255,
		"./ms": 257,
		"./ms-my": 256,
		"./ms-my.js": 256,
		"./ms.js": 257,
		"./mt": 258,
		"./mt.js": 258,
		"./my": 259,
		"./my.js": 259,
		"./nb": 260,
		"./nb.js": 260,
		"./ne": 261,
		"./ne.js": 261,
		"./nl": 263,
		"./nl-be": 262,
		"./nl-be.js": 262,
		"./nl.js": 263,
		"./nn": 264,
		"./nn.js": 264,
		"./oc-lnc": 265,
		"./oc-lnc.js": 265,
		"./pa-in": 266,
		"./pa-in.js": 266,
		"./pl": 267,
		"./pl.js": 267,
		"./pt": 269,
		"./pt-br": 268,
		"./pt-br.js": 268,
		"./pt.js": 269,
		"./ro": 270,
		"./ro.js": 270,
		"./ru": 271,
		"./ru.js": 271,
		"./sd": 272,
		"./sd.js": 272,
		"./se": 273,
		"./se.js": 273,
		"./si": 274,
		"./si.js": 274,
		"./sk": 275,
		"./sk.js": 275,
		"./sl": 276,
		"./sl.js": 276,
		"./sq": 277,
		"./sq.js": 277,
		"./sr": 279,
		"./sr-cyrl": 278,
		"./sr-cyrl.js": 278,
		"./sr.js": 279,
		"./ss": 280,
		"./ss.js": 280,
		"./sv": 281,
		"./sv.js": 281,
		"./sw": 282,
		"./sw.js": 282,
		"./ta": 283,
		"./ta.js": 283,
		"./te": 284,
		"./te.js": 284,
		"./tet": 285,
		"./tet.js": 285,
		"./tg": 286,
		"./tg.js": 286,
		"./th": 287,
		"./th.js": 287,
		"./tk": 288,
		"./tk.js": 288,
		"./tl-ph": 289,
		"./tl-ph.js": 289,
		"./tlh": 290,
		"./tlh.js": 290,
		"./tr": 291,
		"./tr.js": 291,
		"./tzl": 292,
		"./tzl.js": 292,
		"./tzm": 294,
		"./tzm-latn": 293,
		"./tzm-latn.js": 293,
		"./tzm.js": 294,
		"./ug-cn": 295,
		"./ug-cn.js": 295,
		"./uk": 296,
		"./uk.js": 296,
		"./ur": 297,
		"./ur.js": 297,
		"./uz": 299,
		"./uz-latn": 298,
		"./uz-latn.js": 298,
		"./uz.js": 299,
		"./vi": 300,
		"./vi.js": 300,
		"./x-pseudo": 301,
		"./x-pseudo.js": 301,
		"./yo": 302,
		"./yo.js": 302,
		"./zh-cn": 303,
		"./zh-cn.js": 303,
		"./zh-hk": 304,
		"./zh-hk.js": 304,
		"./zh-mo": 305,
		"./zh-mo.js": 305,
		"./zh-tw": 306,
		"./zh-tw.js": 306
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 529;


/***/ }),
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/diplo1.a6a0045.jpg";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/diplo2.306a754.jpg";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/diplo3.fcbd894.jpg";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hd-1.80c47e6.jpg";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hd-2.9a9a584.jpg";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hd-3.5ff264e.jpg";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hd-4.38ca524.jpg";

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hd-5.e3e762d.jpg";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lacan1.080a3db.jpg";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lacan2.4cb2f51.jpg";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lacan3.691bd79.jpg";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/locations-bg.0f9aef3.png";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.05992dd.png";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo2.68e6bcb.png";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(354),
	  /* template */
	  __webpack_require__(598),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(356),
	  /* template */
	  __webpack_require__(609),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(494)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(357),
	  /* template */
	  __webpack_require__(607),
	  /* scopeId */
	  "data-v-973f162c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(493)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(358),
	  /* template */
	  __webpack_require__(606),
	  /* scopeId */
	  "data-v-96ea8926",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(491)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(359),
	  /* template */
	  __webpack_require__(602),
	  /* scopeId */
	  "data-v-733a9c65",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(360),
	  /* template */
	  __webpack_require__(588),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(361),
	  /* template */
	  __webpack_require__(600),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(362),
	  /* template */
	  __webpack_require__(603),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(489)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(363),
	  /* template */
	  __webpack_require__(597),
	  /* scopeId */
	  "data-v-642bed1a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(492)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(364),
	  /* template */
	  __webpack_require__(604),
	  /* scopeId */
	  "data-v-7adc6a32",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(365),
	  /* template */
	  __webpack_require__(590),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(495)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(366),
	  /* template */
	  __webpack_require__(610),
	  /* scopeId */
	  "data-v-ed494f56",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(484)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(367),
	  /* template */
	  __webpack_require__(586),
	  /* scopeId */
	  "data-v-0276f12a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(486)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(368),
	  /* template */
	  __webpack_require__(589),
	  /* scopeId */
	  "data-v-0bc3bb76",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(369),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(485)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(370),
	  /* template */
	  __webpack_require__(587),
	  /* scopeId */
	  "data-v-06f4c179",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(371),
	  /* template */
	  __webpack_require__(595),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(372),
	  /* template */
	  __webpack_require__(594),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(373),
	  /* template */
	  __webpack_require__(605),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(374),
	  /* template */
	  __webpack_require__(591),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(375),
	  /* template */
	  __webpack_require__(601),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(376),
	  /* template */
	  __webpack_require__(611),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(377),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(490)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(378),
	  /* template */
	  __webpack_require__(599),
	  /* scopeId */
	  "data-v-6578d01b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(379),
	  /* template */
	  __webpack_require__(596),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(487)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(380),
	  /* template */
	  __webpack_require__(592),
	  /* scopeId */
	  "data-v-298a0b48",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(381),
	  /* template */
	  __webpack_require__(608),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.locationDetails) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('section', {
	    staticClass: "resort-title"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 hotel-logo"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(308),
	      "alt": "logo hotel"
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "resort-title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.locationDetails.name)
	    }
	  })])])])]), _vm._v(" "), _c('section', {
	    staticClass: "location-details"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row sectiom-reverse"
	  }, [_c('div', {
	    staticClass: "col-lg-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12"
	  }, [_c('div', {
	    staticClass: "available-cabana"
	  }, [_c('div', {
	    staticClass: "available-text"
	  }, [_vm._v("\n                  The following cabana(s) are avaliable on\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "available-data"
	  }, [_c('el-date-picker', {
	    attrs: {
	      "picker-options": _vm.pickerOptions,
	      "type": "daterange",
	      "format": "MM/dd/yyyy",
	      "range-separator": "",
	      "start-placeholder": "Select Date(s)",
	      "end-placeholder": ""
	    },
	    on: {
	      "change": _vm.handleDateClick
	    },
	    model: {
	      value: (_vm.dateFromTo),
	      callback: function($$v) {
	        _vm.dateFromTo = $$v
	      },
	      expression: "dateFromTo"
	    }
	  })], 1)]), _vm._v(" "), _vm._l((_vm.seatTypeOptions), function(seatTypeOption) {
	    return _c('div', {
	      key: seatTypeOption.id,
	      staticClass: "result for-padding"
	    }, [(seatTypeOption.is_available) ? _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-lg-5"
	    }, [(
	      seatTypeOption &&
	      seatTypeOption.fileList &&
	      seatTypeOption.fileList.length
	    ) ? _c('span', [_c('el-carousel', {
	      staticClass: "for-height",
	      attrs: {
	        "autoplay": _vm.autoplay,
	        "arrow": 'never',
	        "indicator-position": 'outside',
	        "trigger": 'click',
	        "height": _vm.imgHight > 767 && _vm.imgHight < 991 ?
	          '400px' :
	          _vm.imgHight < 375 && _vm.imgHight > 319 ?
	          '170px' :
	          '230px'
	      }
	    }, _vm._l((seatTypeOption.fileList), function(item) {
	      return _c('el-carousel-item', {
	        key: item.name
	      }, [_c('el-image', {
	        staticClass: "medium",
	        attrs: {
	          "src": item.url,
	          "preview-src-list": [item.url]
	        }
	      })], 1)
	    }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-7 pl-lg-0"
	    }, [_c('div', {
	      staticClass: "info-section-cabana"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-lg-12 for-pos-button"
	    }, [_c('h3', {
	      staticClass: "resort-title",
	      domProps: {
	        "innerHTML": _vm._s(seatTypeOption.name)
	      }
	    }), _vm._v(" "), _c('div', {
	      domProps: {
	        "innerHTML": _vm._s(seatTypeOption.description)
	      }
	    }), _vm._v(" "), _c('div', [_c('el-row', {
	      staticClass: "wrap-price",
	      attrs: {
	        "gutter": 20
	      }
	    }, [_c('el-col', {
	      staticClass: "text-left",
	      attrs: {
	        "span": _vm.imgHight > 530 ? 6 : 12
	      }
	    }, [_c('strong', [_vm._v("Full day"), _c('br'), _c('b', {
	      staticClass: "guest-price"
	    }, [_vm._v(_vm._s(seatTypeOption.starting_price))])]), _vm._v(" "), (seatTypeOption.seats_left_count <= 3) ? _c('span', {
	      staticClass: "quantity-cabana"
	    }, [_vm._v("ONLY\n                                  " + _vm._s(seatTypeOption.seats_left_count) + "\n                                  LEFT")]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "for-line"
	    }), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": _vm.imgHight > 530 ? 6 : 12
	      }
	    }, [_c('strong', [_vm._v("Up to"), _c('br'), _c('b', {
	      staticClass: "guest-price"
	    }, [_vm._v(_vm._s(seatTypeOption.max_guests) + " guests")])])])], 1), _c('br'), _vm._v(" "), _c('div', {
	      staticClass: "div-btn-book2"
	    }, [_c('el-button', {
	      attrs: {
	        "type": "info"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.handleOpenDialog(seatTypeOption)
	        }
	      }
	    }, [_vm._v("Details")]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.handleBookNow(seatTypeOption.id)
	        }
	      }
	    }, [_vm._v("Book Now!")])], 1)], 1)])])])])]) : _vm._e()])
	  })], 2)])])])]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "",
	      "visible": _vm.dialogVisible,
	      "width": "40%",
	      "before-close": _vm.handleClose
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogVisible = $event
	      }
	    }
	  }, [_c('span', {
	    staticClass: "terms-editor",
	    domProps: {
	      "innerHTML": _vm._s(_vm.locationDetails.terms)
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "warning"
	    },
	    on: {
	      "click": _vm.handleClose
	    }
	  }, [_vm._v("Close")])], 1)])], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.step === 1) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('el-form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    ref: "postForm",
	    attrs: {
	      "id": "postForm",
	      "model": _vm.postForm,
	      "rules": _vm.rules,
	      "auto-complete": "on",
	      "label-position": "left"
	    }
	  }, [_c('p', {
	    staticClass: "phone-input-label"
	  }, [_vm._v("You can enter your phone number below to review or cancel your reservation. ")]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.phone_number,
	      "label": "",
	      "prop": "phone_number"
	    }
	  }, [_c('br'), _vm._v(" "), _c('vue-tel-input', {
	    attrs: {
	      "preferred-countries": _vm.preferred_countries,
	      "only-countries": _vm.only_countries,
	      "default-country": _vm.default_country
	    },
	    on: {
	      "onInput": _vm.onInputPhone,
	      "onValidate": _vm.onValidatePhone
	    },
	    model: {
	      value: (_vm.postForm.phone_number),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "phone_number", $$v)
	      },
	      expression: "postForm.phone_number"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 text-right"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.sendVerificationCode
	    }
	  }, [_vm._v("Send Text")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('el-form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    ref: "loginForm",
	    attrs: {
	      "id": "loginForm",
	      "model": _vm.loginForm,
	      "rules": _vm.loginRules,
	      "auto-complete": "on",
	      "label-position": "left"
	    }
	  }, [_c('p', [_vm._v("Please check your phone and enter your verification code.")]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.verification_code,
	      "label": "",
	      "prop": "verification_code"
	    }
	  }, [_c('br'), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.loginForm.verification_code),
	      callback: function($$v) {
	        _vm.$set(_vm.loginForm, "verification_code", $$v)
	      },
	      expression: "loginForm.verification_code"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 text-right"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.handleLogin
	    }
	  }, [_vm._v("Confirm")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3"
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "partner-form"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-8 offset-lg-2",
	    staticStyle: {
	      "padding": "50px"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    ref: "postForm",
	    attrs: {
	      "id": "postForm",
	      "model": _vm.postForm,
	      "rules": _vm.rules
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.hname,
	      "label": "Hotel Name",
	      "prop": "hname"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.hname),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "hname", $$v)
	      },
	      expression: "postForm.hname"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.fname,
	      "label": "First Name",
	      "prop": "fname"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.fname),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "fname", $$v)
	      },
	      expression: "postForm.fname"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.lname,
	      "label": "Last Name",
	      "prop": "lname"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.lname),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "lname", $$v)
	      },
	      expression: "postForm.lname"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.title,
	      "label": "Title",
	      "prop": "title"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.title),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "title", $$v)
	      },
	      expression: "postForm.title"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.email,
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.email),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "email", $$v)
	      },
	      expression: "postForm.email"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.info,
	      "label": "Additional Information",
	      "prop": "info"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "textarea",
	      "rows": 10
	    },
	    model: {
	      value: (_vm.postForm.info),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "info", $$v)
	      },
	      expression: "postForm.info"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 9
	    }
	  }, [_c('el-button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.submitForm
	    }
	  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12"
	  }, [_c('h2', [_vm._v("Hotel Partner Equiry")]), _vm._v(" "), _c('p', [_vm._v("Questions? Feedback? We want to hear from you! Email us at info@opencabana.com or fill out the below form and we will get back to you within 24 hours.")])])])
	}]}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "locations"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "search-container"
	  }, [_c('div', {
	    staticClass: "row justify-content-md-center"
	  }, [_c('div', {
	    staticClass: "wrap-search-Section"
	  }, [_c('div', {
	    staticClass: "search-wrapper"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "for-padding-responsive"
	  }, [_c('span', {
	    staticClass: "location-select-wrapper"
	  }, [_c('el-select', {
	    staticClass: "locations",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Enter hotel name",
	      "loading": _vm.loading
	    },
	    model: {
	      value: (_vm.location),
	      callback: function($$v) {
	        _vm.location = $$v
	      },
	      expression: "location"
	    }
	  }, _vm._l((_vm.locationLists), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1), _vm._v(" "), _c('i', {
	    staticClass: "el-icon-search"
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "for-border"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "for-padding-responsive"
	  }, [_c('el-date-picker', {
	    attrs: {
	      "picker-options": _vm.pickerOptions,
	      "type": "daterange",
	      "format": "MM/dd/yyyy",
	      "range-separator": "",
	      "start-placeholder": "Select Date(s)",
	      "end-placeholder": ""
	    },
	    model: {
	      value: (_vm.dateFromTo),
	      callback: function($$v) {
	        _vm.dateFromTo = $$v
	      },
	      expression: "dateFromTo"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "for-button"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": (_vm.dateFromTo && _vm.dateFromTo.length < 1) || !_vm.location
	    },
	    on: {
	      "click": _vm.searchLocation
	    }
	  }, [_vm._v("Search")])], 1)])])])])])]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 text-center"
	  }, [_c('h2', {
	    staticClass: "text-xl",
	    staticStyle: {
	      "color": "#777"
	    }
	  }, [_vm._v("\n          Reserve cabanas at the most desirable hotels on\n          "), _c('span', {
	    staticClass: "text-xl",
	    staticStyle: {
	      "color": "#26a1e0"
	    }
	  }, [_vm._v("South Beach.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "div-img-search-section"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(556),
	      "alt": ""
	    }
	  })])
	}]}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "fixed-top"
	  }, [_c('nav', {
	    staticClass: "navbar navbar-expand-lg"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('a', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "href": "#/home"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(557),
	      "alt": "OpenCabana"
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "navbar-toggler",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#navbarSupportedContent",
	      "aria-controls": "navbarSupportedContent",
	      "aria-expanded": "false",
	      "aria-label": "Toggle navigation"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.toggleNavbarMenu()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "navbar-toggler-icon"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "collapse navbar-collapse",
	    attrs: {
	      "id": "navbarSupportedContent"
	    }
	  }, [_c('div', {
	    staticClass: "sidebar-menu-wrapper"
	  }, [_c('ul', {
	    staticClass: "sidebar-menu"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('locations')
	      }
	    }
	  }, [_vm._v("BOOK A CABANA")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "bottom-area text-center"
	  }, [_c('ul', {
	    staticClass: "sidebar-menu"
	  }, [(!_vm.isLoggedIn) ? _c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('login')
	      }
	    }
	  }, [_vm._v("GUEST LOGIN")])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.logout.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("LOGOUT")])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("© " + _vm._s(_vm.date) + " - All rights reserved.")])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "social-group"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.facebook.com/opencabana/"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-facebook"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.twitter.com/opencabana/"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-twitter"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.instagram.com/opencabana/"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-instagram"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.youtube.com/opencabana/"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-youtube"
	  })])])
	}]}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "page-copy"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [_c('h1', [_vm._v("1616 SE 8th Street"), _c('br'), _vm._v("\n        Fort Lauderdale Florida 33316"), _c('br'), _vm._v("\n        954-300-4445"), _c('br'), _vm._v("\n        corp@opencabana.com")])])])])])
	}]}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-reservation"
	  }, [_c('section', {
	    staticClass: "resort-title"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 hotel-logo"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(308),
	      "alt": "logo hotel"
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "resort-title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.locationDetails.name)
	    }
	  })])])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "reservation-form"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [(_vm.step === 1) ? _c('el-card', {
	    staticClass: "box-card"
	  }, [_c('div', {
	    staticClass: "available-text",
	    staticStyle: {
	      "font-size": "20px",
	      "margin-bottom": "30px"
	    }
	  }, [_vm._v("\n          Click on your preferred location(s)\n        ")]), _vm._v(" "), _c('googlemaps-map', {
	    ref: "map",
	    staticClass: "googleMap",
	    attrs: {
	      "center": _vm.mapCenter,
	      "zoom": _vm.mapZoom,
	      "options": _vm.mapOptions,
	      "heading": _vm.mapHeading,
	      "tilt": _vm.mapTilt
	    },
	    on: {
	      "update:center": function($event) {
	        _vm.mapCenter = $event
	      },
	      "update:zoom": function($event) {
	        _vm.mapZoom = $event
	      },
	      "update:options": function($event) {
	        _vm.mapOptions = $event
	      },
	      "update:heading": function($event) {
	        _vm.mapHeading = $event
	      },
	      "update:tilt": function($event) {
	        _vm.mapTilt = $event
	      }
	    }
	  }, _vm._l((_vm.markers), function(m, index) {
	    return _c('gmap-custom-marker', {
	      key: index,
	      staticClass: "map-marker",
	      attrs: {
	        "position": m.position,
	        "z-index": index
	      }
	    }, [_c('el-tooltip', {
	      staticClass: "item",
	      attrs: {
	        "content": m.tooltip,
	        "effect": "dark",
	        "placement": "top"
	      }
	    }, [_c('el-button', {
	      class: _vm.mapMarkerClass(m),
	      attrs: {
	        "type": "default"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.mapMarkerClick(m)
	        }
	      }
	    }, [_vm._v(_vm._s(m.seat_no))])], 1)], 1)
	  }), 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "20px",
	      "text-align": "right"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleMarkerSelected(true)
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.selectedSeats && _vm.selectedSeats.length < 1
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleMarkerSelected(false)
	      }
	    }
	  }, [_vm._v("Continue")])], 1)], 1) : _vm._e(), _c('br'), _vm._v(" "), _c('el-form', {
	    ref: "postForm",
	    attrs: {
	      "id": "postForm",
	      "model": _vm.postForm,
	      "rules": _vm.rules
	    }
	  }, [(_vm.step === 2) ? _c('div', [_c('el-card', {
	    staticClass: "box-card"
	  }, [(_vm.postForm.res_date_type) ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "picker-options": _vm.pickerOptions,
	      "type": "date",
	      "format": "MM/dd/yyyy",
	      "placeholder": "Pick any Date"
	    },
	    on: {
	      "change": _vm.onSingleDatePick
	    },
	    model: {
	      value: (_vm.postForm.reservation_date_single),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "reservation_date_single", $$v)
	      },
	      expression: "postForm.reservation_date_single"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.postForm.res_date_type) ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.reservation_date,
	      "label": "",
	      "prop": "reservation_date"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "picker-options": _vm.pickerOptions,
	      "type": "daterange",
	      "format": "MM/dd/yyyy",
	      "range-separator": "To",
	      "start-placeholder": "Select Date From",
	      "end-placeholder": "Select Date To"
	    },
	    on: {
	      "change": _vm.onMultiDatePick
	    },
	    model: {
	      value: (_vm.postForm.reservation_date),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "reservation_date", $$v)
	      },
	      expression: "postForm.reservation_date"
	    }
	  })], 1)], 1)], 1) : _vm._e()], 1), _c('br'), _vm._v(" "), _c('el-tabs', {
	    attrs: {
	      "closable": _vm.tabClosable,
	      "type": "border-card"
	    },
	    on: {
	      "tab-click": _vm.tabClick,
	      "edit": _vm.tabRemove,
	      "tab-remove": _vm.tabRemove
	    },
	    model: {
	      value: (_vm.editableTabsValue),
	      callback: function($$v) {
	        _vm.editableTabsValue = $$v
	      },
	      expression: "editableTabsValue"
	    }
	  }, _vm._l((_vm.tabs), function(tab, tabIndex) {
	    return _c('el-tab-pane', {
	      key: tabIndex,
	      attrs: {
	        "label": tab.title,
	        "name": tab.name
	      }
	    }, [_c('el-checkbox-group', {
	      attrs: {
	        "fill": "#46be8a"
	      },
	      model: {
	        value: (tab.reserved),
	        callback: function($$v) {
	          _vm.$set(tab, "reserved", $$v)
	        },
	        expression: "tab.reserved"
	      }
	    }, _vm._l((tab.seats), function(seat) {
	      return _c('el-checkbox-button', {
	        key: seat.id,
	        staticStyle: {
	          "margin-left": "10px",
	          "margin-bottom": "10px"
	        },
	        attrs: {
	          "label": seat.seat_no,
	          "checked": seat.reserved,
	          "disabled": seat.booked
	        }
	      }, [(!seat.booked) ? _c('span', {
	        staticClass: "box-color"
	      }, [_c('span', {
	        staticClass: "uppercase"
	      }, [_vm._v(_vm._s(seat.seat_type))]), _vm._v("\n                    " + _vm._s(seat.seat_no)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("$" + _vm._s(seat.seat_price) + " ")])]) : _vm._e(), _vm._v(" "), (seat.booked) ? _c('span', {
	        staticClass: "box-color booked"
	      }, [_c('span', {
	        staticClass: "uppercase"
	      }, [_vm._v(_vm._s(seat.seat_type))]), _vm._v("\n                    " + _vm._s(seat.seat_no)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("$" + _vm._s(seat.seat_price) + " ")])]) : _vm._e()])
	    }), 1)], 1)
	  }), 1), _c('br'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "20px",
	      "text-align": "right"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleSeatSelected(true)
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.seatAmount < 1
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleSeatSelected(false)
	      }
	    }
	  }, [_vm._v("Continue")])], 1)], 1) : (_vm.step === 3) ? _c('div', [_c('el-card', {
	    staticClass: "box-card"
	  }, [(_vm.locationDetails.refund_within_display) ? _c('div', [_c('strong', [_vm._v("Refund Policy")]), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-warning",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_vm._v("\n                Requires cancellation " + _vm._s(_vm.locationDetails.refund_within_display) + " prior to booking date.\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.locationDetails.terms) ? _c('div', [_c('strong', [_vm._v("Terms & Conditions")]), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-primary terms-editor",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.locationDetails.terms)
	    }
	  })])]) : _vm._e()]), _c('br'), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('stripe-checkout', {
	    ref: "stripeCheckoutRef",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "product": _vm.product,
	      "stripe-key": _vm.stripeKey,
	      "button": "",
	      "button-class": "btn btn-primary mt-5",
	      "on-success": "broadcast"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "box-card"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticClass: "input-white",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.first_name,
	      "label": "First Name",
	      "prop": "first_name"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.first_name),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "first_name", $$v)
	      },
	      expression: "postForm.first_name"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    staticClass: "input-white",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.last_name,
	      "label": "Last Name",
	      "prop": "last_name"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.last_name),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "last_name", $$v)
	      },
	      expression: "postForm.last_name"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticClass: "input-white",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.phone_number,
	      "label": "Mobile Phone Number",
	      "prop": "phone_number"
	    }
	  }, [_c('div', [_c('vue-tel-input', {
	    staticClass: "phoneNumber",
	    attrs: {
	      "preferred-countries": _vm.preferred_countries,
	      "only-countries": _vm.only_countries,
	      "default-country": _vm.default_country,
	      "placeholder": ""
	    },
	    on: {
	      "onInput": _vm.onInputPhone,
	      "onValidate": _vm.onValidatePhone
	    },
	    model: {
	      value: (_vm.postForm.phone_number),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "phone_number", $$v)
	      },
	      expression: "postForm.phone_number"
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-col', {
	    staticClass: "input-white",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.email,
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.email),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "email", $$v)
	      },
	      expression: "postForm.email"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticClass: "input-white",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.first_name,
	      "label": "# Guests",
	      "prop": "no_of_guests"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.no_of_guests),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "no_of_guests", $$v)
	      },
	      expression: "postForm.no_of_guests"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    staticClass: "input-white",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.room_no,
	      "label": "Room #",
	      "prop": "room_no"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.room_no),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "room_no", $$v)
	      },
	      expression: "postForm.room_no"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticClass: "input-white",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.p__errors.last_name,
	      "label": "Requests or Notes",
	      "prop": "notes"
	    }
	  }, [_c('el-input', {
	    staticClass: "article-textarea",
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.postForm.notes),
	      callback: function($$v) {
	        _vm.$set(_vm.postForm, "notes", $$v)
	      },
	      expression: "postForm.notes"
	    }
	  })], 1)], 1)], 1)], 1), _c('br'), _vm._v(" "), (_vm.tabs && _vm.tabs[0]) ? _c('el-card', {
	    staticClass: "box-card",
	    staticStyle: {
	      "font-size": "18px"
	    }
	  }, [_vm._l((_vm.tabs[0].seats), function(seatRow) {
	    return _c('div', {
	      staticClass: "row"
	    }, [(_vm.tabs[0].reserved.indexOf(seatRow.seat_no) > -1) ? _c('div', {
	      staticClass: "col-lg-12"
	    }, [_vm._v("\n                    " + _vm._s(seatRow.seat_label) + " " + _vm._s(seatRow.seat_no)), _c('span', {
	      staticStyle: {
	        "margin-left": "50px"
	      }
	    }, [_vm._v(_vm._s(_vm.tabs[0].title)), (_vm.tabs.length > 1) ? _c('span', [_vm._v(" - " + _vm._s(_vm.tabs[_vm.tabs.length - 1].title))]) : _vm._e()]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "margin-left": "50px"
	      }
	    }, [_vm._v("$" + _vm._s(seatRow.seat_price * _vm.tabs.length))]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "text"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.handleRemoveSeat(seatRow.seat_no)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "el-icon-delete"
	    })])], 1) : _vm._e()])
	  }), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('div', [_vm._v("\n                      Service Fee: "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.serviceFeeAmountDisplay)
	    }
	  }), _vm._v(" "), _c('el-tooltip', {
	    attrs: {
	      "placement": "top"
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "content"
	    },
	    slot: "content"
	  }, [_vm._v("\n                          This fee is for the staff that sets up the cabana with\n                          towels.\n                        ")]), _vm._v(" "), _c('i', {
	    staticClass: "el-icon-question"
	  })])], 1), _vm._v(" "), _c('div', [_vm._v("Tax: "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.taxAmountDisplay)
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("Total: "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.amountDisplay)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6 amount-display"
	  }, [(
	    _vm.websiteCommissionPercent > 0 &&
	    _vm.websiteCommissionPercent < 100
	  ) ? _c('div', [_vm._v("\n                      Deposit Amount (" + _vm._s(_vm.websiteCommissionPercent) + "%):\n                      "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.depositAmountDisplay)
	    }
	  })]) : _vm._e(), _vm._v(" "), (
	    _vm.websiteCommissionPercent > 0 &&
	    _vm.websiteCommissionPercent < 100
	  ) ? _c('div', [_vm._v("\n                      Balance Due at Check In:\n                      "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.dueAmountDisplay)
	    }
	  })]) : _vm._e()])])], 2) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "text-right"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm(true)
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), (_vm.depositAmount > 0) ? _c('el-button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm(false)
	      }
	    }
	  }, [_vm._v("Pay Now " + _vm._s(_vm.depositAmountDisplay))]) : _vm._e(), _vm._v(" "), (_vm.depositAmount < 1) ? _c('el-button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm(false)
	      }
	    }
	  }, [_vm._v("Submit Reservation")]) : _vm._e()], 1)], 1)], 1), _c('br')], 1) : _vm._e()])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('svg', {
	    staticClass: "hamburger",
	    class: {
	      'is-active': _vm.isActive
	    },
	    attrs: {
	      "t": "1492500959545",
	      "viewBox": "0 0 1024 1024",
	      "version": "1.1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "p-id": "1691",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "width": "64",
	      "height": "64"
	    },
	    on: {
	      "click": _vm.toggleClick
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z",
	      "p-id": "1692"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z",
	      "p-id": "1693"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z",
	      "p-id": "1694"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "page-copy"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h1', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('p', [_vm._v("The OpenCabana privacy policy (the \"Privacy Policy\") is intended to inform you of our policies and practices regarding the collection, use and disclosure of personal information and other information you submit to us through OpenCabana. By accessing or otherwise using the OpenCabana website, e-mails or other services (collectively \"OpenCabana\"), you agree to the terms and conditions of this Privacy Policy (which is incorporated into and forms a part of the OpenCabana Terms and Conditions of Use) and consent to the processing of your information according to the Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Collection of Information")]), _vm._v(" OpenCabana collects information from users at different points on the website. Some of the information is collected when you provide us with information and other information is collected through your use of our websites, mobile apps and from activities while visiting our hotel partners.")]), _vm._v(" "), _c('p', [_vm._v("We collect information that you give to us. At the time you register, create an account or fill in forms on our website, or you send us a communication, we collect and store such information as you may provide. We may collect specific information such as your name, address, telephone number, e-mail address, a unique login name, password, and password validation. We may also collect information when you complete a survey, enter a contest or promotion we sponsor, or when you report a problem with our website. To enable payment for goods or services purchased through OpenCabana, such as Day Passes, we collect and store billing, credit card or other payment information.")]), _vm._v(" "), _c('p', [_vm._v("If you provide feedback to us, we may use and disclose such feedback for any purpose, provided we do not associate such feedback with your personal information. We will collect any information contained in such feedback and will treat the personal information in it in accordance with this Privacy Policy. You agree that any such comments and any e-mail we receive becomes our property. We may use feedback for marketing purposes or to add to or modify our services without paying any royalties or other compensation to you.")]), _vm._v(" "), _c('p', [_vm._v("We may automatically collect certain information when you use this website, such as your location, a device identifier, IP address, operating system, the browser, web pages viewed, etc. We use the personally identifiable information mentioned above to develop, deliver, protect, and improve our products, services, content, and customer communications.")]), _vm._v(" "), _c('p', [_vm._v("As most websites do, we use \"cookies\" to collect information about your use of the website. Cookies are small files stored by your browser on your hard drive. We use the information that we collect in this way to better understand our users' interaction with our website or services and to optimize the user experience. Though most browsers automatically accept cookies, you are free to disable cookies in your browser settings, but please note that the full features of this website may be unavailable as a result.")]), _vm._v(" "), _c('p', [_vm._v("Certain information you post or provide through OpenCabana for public posting, such as your name, profile, comments and reviews, may be shared with other users and posted on publicly available portions of OpenCabana, including without limitation, social media applications and other public fora in which you choose to participate. Please keep in mind that if you choose to disclose personal information when posting comments or other information or content through OpenCabana, this information may become publicly available and may be collected and used by others, including people outside the OpenCabana community. It is up to you to make sure you are comfortable with the information you choose to provide us and the information you choose to publish. We will not have any obligations with respect to any information that you post to parts of OpenCabana available to others, and recommend that you use caution when giving out personal information to others through social media networks or otherwise.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Use of Your Information")]), _vm._v(" In general, personal information and other information you submit or share with us is used for the following purposes by OpenCabana: to enable your access to our services; to provide, maintain, protect, develop and improve OpenCabana; to fulfill your requests for products and services; to customize the content and advertisements you receive from us and our trusted partners; and to offer you additional information, opportunities, promotions and functionality from us or on our behalf, or from our partners or our advertisers at your request.")]), _vm._v(" "), _c('p', [_vm._v("We may provide your personal information to third-party service providers or affiliates who work on behalf of or with us to provide some of the services and features of OpenCabana and to help us communicate with you. Examples of such services include sending e-mails, analyzing data, providing marketing assistance, processing payments (including credit card payments) and providing customer service. We limit information provided to the aforementioned affiliates and third party service providers to the extent necessary for them to provide the services and require such service providers to promise not to use such information except as necessary to provide the relevant services to us.")]), _vm._v(" "), _c('p', [_vm._v("We may share some or all of your personal information with hotels or other merchants for which you have purchased Day Passes or other goods or services for their commercial purposes and to provide the Day Passes or other goods or services. If you do not want us to use or disclose personal information collected about you in the manner identified in this Privacy Policy, you may not use OpenCabana. Certain goods or services offered by OpenCabana may expressly require you to submit information for fulfillment at the point of purchase, and hotels or other merchants may separately request information from you as necessary to redeem Day Passes or other goods or services you have purchased, or for their own purposes. A hotel's or other merchant's collection and use of any information shall be governed by that entity's own privacy policy.")]), _vm._v(" "), _c('p', [_vm._v("We may use your IP address to help diagnose problems with our server, to manage our website and to enhance our website based on the usage pattern data we receive.")]), _vm._v(" "), _c('p', [_vm._v("We may use your personal information for internal purposes such as auditing, data analysis, and research to improve our products and services. We use Google Analytics to better understand how visitors interact with our site. This service provides non-personally identifiable data including but not limited to data on where visitors came from, what actions they took on our site and where visitors went when they left our site. If you would like to learn more about this service, or about choices to opt out from it, please visit "), _c('a', {
	    attrs: {
	      "href": "http://www.tools.google.com/dlpage/gaoptout",
	      "target": "_blank"
	    }
	  }, [_vm._v("www.tools.google.com/dlpage/gaoptout")])]), _vm._v(" "), _c('p', [_vm._v("In the event we go through a business transition such as a merger, acquisition by another company or sale of all or a portion of our assets, your personal information may be among the assets transferred. You acknowledge that such transfers may occur and are permitted by this Privacy Policy, and that any acquirer of ours or that acquirer's assets may continue to process your personal information as set forth in this Privacy Policy.")]), _vm._v(" "), _c('p', [_vm._v("We may use or disclose your personal information to resolve disputes, investigate problems, or enforce our Terms and Conditions of Use. We may also disclose your personal information if we believe in good faith that such disclosure is necessary to (a) comply with relevant laws or to respond to subpoenas or warrants served on us; or (b) to protect and defend our rights or property, you, or third parties. You hereby consent to us sharing your personal information under the circumstances described herein.")]), _vm._v(" "), _c('p', [_vm._v("Your Choices Regarding Your Personal Information We offer you choices regarding the collection, use and sharing of your personal information. You have a right at any time to stop us from contacting you for marketing purposes. When you receive promotional communications from us, you may indicate a preference to stop receiving further promotional communications from us and you will have the opportunity to \"opt-out\" by following the unsubscribe instructions provided in the promotional e-mail you receive or by contacting us directly at info@OpenCabana.com.")]), _vm._v(" "), _c('p', [_vm._v("Despite your indicated e-mail marketing preferences, we may send you administrative e-mails regarding OpenCabana, including, for example, administrative and transactional confirmations, and notices of updates to our Privacy Policy if we choose to provide such notices to you in this manner.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Security")]), _vm._v(" We employ reasonable and current security methods to prevent unauthorized access, maintain data accuracy, and ensure correct use of information.")]), _vm._v(" "), _c('p', [_vm._v("No data transmission over the Internet or any wireless network can be guaranteed to be perfectly secure. As a result, while we try to protect your personal information, we cannot ensure or guarantee the security of any information you transmit to us, and you do so at your own risk.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Children's Privacy")]), _vm._v(" OpenCabana will never knowingly request or collect personal information from any person under 13 years of age without prior verifiable parental consent. If you are under 13 years old, please do not provide your information on our website. If we become aware that an individual is under the age of 13 and has submitted any information to OpenCabana for any purpose without prior verifiable parental consent, we will delete his or her information from our files.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Links")]), _vm._v(" OpenCabana may contain links to other websites. Please be aware that we are not responsible for the privacy practices or the content of such other websites. We encourage our users to read the privacy statements of each and every website they visit. This Privacy Policy applies solely to information collected by us through OpenCabana and does not apply to these third-party websites. The ability to access information of third parties from OpenCabana, or links to other websites, is for your convenience and does not signify our endorsement of such third parties, their products, their services, other websites or their content.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("California Residents")]), _vm._v(" California law entitles residents to ask us for a notice describing what categories of personal information we share with third parties for those entities direct marketing purposes. OpenCabana does not provide any personal information to third parties for their own direct marketing purposes; provided, however, that OpenCabana will provide your personal information to any hotels or resorts for which you purchase products and services for the hotel or resort's use in connection with providing such products and services. If you want to request a notice or have any questions about OpenCabana privacy practices, please contact us at info@OpenCabana.com.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Access to Your Information")]), _vm._v(" If you wish to (a) request access to, correct or delete any personal information that you have provided to us; or (b) opt out of receiving marketing messages from OpenCabana, please notify us by e-mail at info@OpenCabana.com. Once you register on the website, you may also log into your account and update your personal information and settings.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Changes to this Privacy Policy")]), _vm._v(" OpenCabana may revise this Privacy Policy from time to time. If we decide to change the Privacy Policy, we will post the revised policy here. As we may make changes at any time without notifying you, we suggest that you periodically consult this Privacy Policy. Please note that our rights to use any information collected will be based on the privacy policy in effect at the time the information is used. If you do not accept our policies, you may not use this website.")]), _vm._v(" "), _c('p', [_vm._v("If you have any questions about our Privacy Policy, please contact us by e-mail at "), _c('a', {
	    attrs: {
	      "href": "mailto:info@OpenCabana.com"
	    }
	  }, [_vm._v("info@OpenCabana.com")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Last Updated: April 20, 2018")])])])])])
	}]}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "page-copy"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [_c('h1', [_vm._v("Please download latest OpenCabana Guest App!")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://itunes.apple.com/us/app/opencabana/id1267799200?mt=8&ign-mpt=uo%3D4"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.applePlayBtn
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "app-store-button",
	    attrs: {
	      "href": "https://play.google.com/store/apps/details?id=com.opencabanaguest"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.googlePlayBtn
	    }
	  })])])])])])
	},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    style: ({
	      opacity: _vm.opacity
	    })
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "app-main",
	    class: {
	      'mr-top': !_vm.seeNavbarSidebar
	    }
	  }, [_c('keep-alive', [_c('router-view', {
	    key: _vm.key
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "confirmation"
	    }
	  }, [(_vm.confirmation) ? _c('div', {
	    staticClass: "container print"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "header no-display"
	  }, [_vm._v("\n        Reservation Confirmation\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "body"
	  }, [_c('div', {
	    staticClass: "no-display"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-8"
	  }, [_c('h3', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.location_name)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-4",
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("\n                  Date: "), (_vm.confirmation.last_updated_at) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.last_updated_at)
	    }
	  }) : _vm._e()])]), _vm._v(" "), (_vm.confirmation.location_address) ? _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.location_address)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.confirmation.booking_no) ? _c('p', {
	    domProps: {
	      "innerHTML": _vm._s('Bookind ID: #' + _vm.confirmation.booking_no)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.confirmation.reserved_from_display && _vm.confirmation.reserved_to_display) ? _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.reserved_from_display + ' - ' + _vm.confirmation.reserved_to_display)
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-12"
	  }, [_c('table', {
	    staticClass: "booking-table",
	    attrs: {
	      "width": "100%"
	    }
	  }, [_vm._m(1), _vm._v(" "), (_vm.confirmation.seat_dates) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('table', {
	    staticClass: "booking-table-inner",
	    attrs: {
	      "width": "100%"
	    }
	  }, _vm._l((_vm.confirmation.seat_dates), function(seat_date) {
	    return _c('tr', [_c('td', {
	      staticStyle: {
	        "padding-left": "0px"
	      },
	      attrs: {
	        "width": "50%"
	      }
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(seat_date.seat_display)
	      }
	    }), _vm._v(" -\n                          "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(seat_date.from_date)
	      }
	    })]), _vm._v(" "), _c('td', {
	      attrs: {
	        "width": "25%"
	      }
	    }), _vm._v(" "), _c('td', {
	      attrs: {
	        "width": "25%"
	      },
	      domProps: {
	        "innerHTML": _vm._s(seat_date.seat_amount_display)
	      }
	    })])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.confirmation.food_package) ? _c('tr', [_c('td', [_c('div', {
	    staticClass: "product-title"
	  }, [_vm._v("\n                      Food\n                    ")]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.food_package)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-desc",
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.food_package_desc)
	    }
	  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.food_package_amount_disp)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.confirmation.tax_amount_display) ? _c('tr', [_c('td'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('td', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.tax_amount_display)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.confirmation.service_fee_amount_display) ? _c('tr', [_c('td'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('td', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.service_fee_amount_display)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.confirmation.total_amount_display) ? _c('tr', [_c('td'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('td', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.total_amount_display)
	    }
	  })]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), (_vm.confirmation.location_terms) ? _c('div', {
	    staticClass: "terms no-display"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.location_terms)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.confirmation.location_description) ? _c('div', {
	    staticClass: "desc no-display"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmation.location_description)
	    }
	  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "no-print text-big text-center"
	  }, [_vm._v("\n          Your reservation has been submitted."), _c('br'), _c('br'), _vm._v("\n\n          You will receive an email and a text with your reservation details "), (_vm.confirmation.email) ? _c('span', [_vm._v("at " + _vm._s(_vm.confirmation.email))]) : _vm._e(), _vm._v("."), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
	    staticClass: "row no-print"
	  }, [_c('div', {
	    staticClass: "col-12 text-right"
	  }, [_c('a', {
	    staticClass: "btn el-button btn-primary mt-5",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doPrint()
	      }
	    }
	  }, [_vm._v("Print Receipt")]), _vm._v(" "), (!_vm.isLoggedIn) ? _c('a', {
	    staticClass: "btn  el-button  btn-success mt-5",
	    attrs: {
	      "href": "#/home"
	    }
	  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('a', {
	    staticClass: "btn el-button  btn-primary mt-5",
	    attrs: {
	      "href": "#/dashboard"
	    }
	  }, [_vm._v("Done")]) : _vm._e()])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title no-display"
	  }, [_c('img', {
	    staticClass: "inline-text",
	    attrs: {
	      "alt": "OpenCabana",
	      "src": "https://api.opencabana.com/images/logo.png"
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("OpenCabana")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  }, [_vm._v("\n                    Description\n                  ")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "25%"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "25%"
	    }
	  }, [_vm._v("\n                    Amount\n                  ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('strong', [_vm._v("Tax")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('strong', [_vm._v("Service Fee")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('strong', [_vm._v("Total")])])
	}]}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-wrapper"
	  }, [(_vm.device === 'mobile' && _vm.sidebar.opened) ? _c('div', {
	    staticClass: "drawer-bg",
	    on: {
	      "click": _vm.handleClickOutside
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.seeNavbarSidebar) ? _c('sidebar', {
	    staticClass: "sidebar-container"
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main-container"
	  }, [(!_vm.seeNavbarSidebar) ? _c('navbar') : _vm._e(), _vm._v(" "), _c('app-main')], 1), _vm._v(" "), _c('Footer')], 1)
	},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "page-copy"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h1', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('p', [_vm._v("The OpenCabana privacy policy (the \"Privacy Policy\") is intended to inform you of our policies and practices regarding the collection, use and disclosure of personal information and other information you submit to us through OpenCabana. By accessing or otherwise using the OpenCabana website, e-mails or other services (collectively \"OpenCabana\"), you agree to the terms and conditions of this Privacy Policy (which is incorporated into and forms a part of the OpenCabana Terms and Conditions of Use) and consent to the processing of your information according to the Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Collection of Information")]), _vm._v(" OpenCabana collects information from users at different points on the website. Some of the information is collected when you provide us with information and other information is collected through your use of our websites, mobile apps and from activities while visiting our hotel partners.")]), _vm._v(" "), _c('p', [_vm._v("We collect information that you give to us. At the time you register, create an account or fill in forms on our website, or you send us a communication, we collect and store such information as you may provide. We may collect specific information such as your name, address, telephone number, e-mail address, a unique login name, password, and password validation. We may also collect information when you complete a survey, enter a contest or promotion we sponsor, or when you report a problem with our website. To enable payment for goods or services purchased through OpenCabana, such as Day Passes, we collect and store billing, credit card or other payment information.")]), _vm._v(" "), _c('p', [_vm._v("If you provide feedback to us, we may use and disclose such feedback for any purpose, provided we do not associate such feedback with your personal information. We will collect any information contained in such feedback and will treat the personal information in it in accordance with this Privacy Policy. You agree that any such comments and any e-mail we receive becomes our property. We may use feedback for marketing purposes or to add to or modify our services without paying any royalties or other compensation to you.")]), _vm._v(" "), _c('p', [_vm._v("We may automatically collect certain information when you use this website, such as your location, a device identifier, IP address, operating system, the browser, web pages viewed, etc. We use the personally identifiable information mentioned above to develop, deliver, protect, and improve our products, services, content, and customer communications.")]), _vm._v(" "), _c('p', [_vm._v("As most websites do, we use \"cookies\" to collect information about your use of the website. Cookies are small files stored by your browser on your hard drive. We use the information that we collect in this way to better understand our users' interaction with our website or services and to optimize the user experience. Though most browsers automatically accept cookies, you are free to disable cookies in your browser settings, but please note that the full features of this website may be unavailable as a result.")]), _vm._v(" "), _c('p', [_vm._v("Certain information you post or provide through OpenCabana for public posting, such as your name, profile, comments and reviews, may be shared with other users and posted on publicly available portions of OpenCabana, including without limitation, social media applications and other public fora in which you choose to participate. Please keep in mind that if you choose to disclose personal information when posting comments or other information or content through OpenCabana, this information may become publicly available and may be collected and used by others, including people outside the OpenCabana community. It is up to you to make sure you are comfortable with the information you choose to provide us and the information you choose to publish. We will not have any obligations with respect to any information that you post to parts of OpenCabana available to others, and recommend that you use caution when giving out personal information to others through social media networks or otherwise.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Use of Your Information")]), _vm._v(" In general, personal information and other information you submit or share with us is used for the following purposes by OpenCabana: to enable your access to our services; to provide, maintain, protect, develop and improve OpenCabana; to fulfill your requests for products and services; to customize the content and advertisements you receive from us and our trusted partners; and to offer you additional information, opportunities, promotions and functionality from us or on our behalf, or from our partners or our advertisers at your request.")]), _vm._v(" "), _c('p', [_vm._v("We may provide your personal information to third-party service providers or affiliates who work on behalf of or with us to provide some of the services and features of OpenCabana and to help us communicate with you. Examples of such services include sending e-mails, analyzing data, providing marketing assistance, processing payments (including credit card payments) and providing customer service. We limit information provided to the aforementioned affiliates and third party service providers to the extent necessary for them to provide the services and require such service providers to promise not to use such information except as necessary to provide the relevant services to us.")]), _vm._v(" "), _c('p', [_vm._v("We may share some or all of your personal information with hotels or other merchants for which you have purchased Day Passes or other goods or services for their commercial purposes and to provide the Day Passes or other goods or services. If you do not want us to use or disclose personal information collected about you in the manner identified in this Privacy Policy, you may not use OpenCabana. Certain goods or services offered by OpenCabana may expressly require you to submit information for fulfillment at the point of purchase, and hotels or other merchants may separately request information from you as necessary to redeem Day Passes or other goods or services you have purchased, or for their own purposes. A hotel's or other merchant's collection and use of any information shall be governed by that entity's own privacy policy.")]), _vm._v(" "), _c('p', [_vm._v("We may use your IP address to help diagnose problems with our server, to manage our website and to enhance our website based on the usage pattern data we receive.")]), _vm._v(" "), _c('p', [_vm._v("We may use your personal information for internal purposes such as auditing, data analysis, and research to improve our products and services. We use Google Analytics to better understand how visitors interact with our site. This service provides non-personally identifiable data including but not limited to data on where visitors came from, what actions they took on our site and where visitors went when they left our site. If you would like to learn more about this service, or about choices to opt out from it, please visit "), _c('a', {
	    attrs: {
	      "href": "http://www.tools.google.com/dlpage/gaoptout",
	      "target": "_blank"
	    }
	  }, [_vm._v("www.tools.google.com/dlpage/gaoptout")])]), _vm._v(" "), _c('p', [_vm._v("In the event we go through a business transition such as a merger, acquisition by another company or sale of all or a portion of our assets, your personal information may be among the assets transferred. You acknowledge that such transfers may occur and are permitted by this Privacy Policy, and that any acquirer of ours or that acquirer's assets may continue to process your personal information as set forth in this Privacy Policy.")]), _vm._v(" "), _c('p', [_vm._v("We may use or disclose your personal information to resolve disputes, investigate problems, or enforce our Terms and Conditions of Use. We may also disclose your personal information if we believe in good faith that such disclosure is necessary to (a) comply with relevant laws or to respond to subpoenas or warrants served on us; or (b) to protect and defend our rights or property, you, or third parties. You hereby consent to us sharing your personal information under the circumstances described herein.")]), _vm._v(" "), _c('p', [_vm._v("Your Choices Regarding Your Personal Information We offer you choices regarding the collection, use and sharing of your personal information. You have a right at any time to stop us from contacting you for marketing purposes. When you receive promotional communications from us, you may indicate a preference to stop receiving further promotional communications from us and you will have the opportunity to \"opt-out\" by following the unsubscribe instructions provided in the promotional e-mail you receive or by contacting us directly at info@OpenCabana.com.")]), _vm._v(" "), _c('p', [_vm._v("Despite your indicated e-mail marketing preferences, we may send you administrative e-mails regarding OpenCabana, including, for example, administrative and transactional confirmations, and notices of updates to our Privacy Policy if we choose to provide such notices to you in this manner.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Security")]), _vm._v(" We employ reasonable and current security methods to prevent unauthorized access, maintain data accuracy, and ensure correct use of information.")]), _vm._v(" "), _c('p', [_vm._v("No data transmission over the Internet or any wireless network can be guaranteed to be perfectly secure. As a result, while we try to protect your personal information, we cannot ensure or guarantee the security of any information you transmit to us, and you do so at your own risk.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Children's Privacy")]), _vm._v(" OpenCabana will never knowingly request or collect personal information from any person under 13 years of age without prior verifiable parental consent. If you are under 13 years old, please do not provide your information on our website. If we become aware that an individual is under the age of 13 and has submitted any information to OpenCabana for any purpose without prior verifiable parental consent, we will delete his or her information from our files.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Links")]), _vm._v(" OpenCabana may contain links to other websites. Please be aware that we are not responsible for the privacy practices or the content of such other websites. We encourage our users to read the privacy statements of each and every website they visit. This Privacy Policy applies solely to information collected by us through OpenCabana and does not apply to these third-party websites. The ability to access information of third parties from OpenCabana, or links to other websites, is for your convenience and does not signify our endorsement of such third parties, their products, their services, other websites or their content.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("California Residents")]), _vm._v(" California law entitles residents to ask us for a notice describing what categories of personal information we share with third parties for those entities direct marketing purposes. OpenCabana does not provide any personal information to third parties for their own direct marketing purposes; provided, however, that OpenCabana will provide your personal information to any hotels or resorts for which you purchase products and services for the hotel or resort's use in connection with providing such products and services. If you want to request a notice or have any questions about OpenCabana privacy practices, please contact us at info@OpenCabana.com.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Access to Your Information")]), _vm._v(" If you wish to (a) request access to, correct or delete any personal information that you have provided to us; or (b) opt out of receiving marketing messages from OpenCabana, please notify us by e-mail at info@OpenCabana.com. Once you register on the website, you may also log into your account and update your personal information and settings.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Changes to this Privacy Policy")]), _vm._v(" OpenCabana may revise this Privacy Policy from time to time. If we decide to change the Privacy Policy, we will post the revised policy here. As we may make changes at any time without notifying you, we suggest that you periodically consult this Privacy Policy. Please note that our rights to use any information collected will be based on the privacy policy in effect at the time the information is used. If you do not accept our policies, you may not use this website.")]), _vm._v(" "), _c('p', [_vm._v("If you have any questions about our Privacy Policy, please contact us by e-mail at "), _c('a', {
	    attrs: {
	      "href": "mailto:info@OpenCabana.com"
	    }
	  }, [_vm._v("info@OpenCabana.com")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Last Updated: April 20, 2018")])])])])])
	}]}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "home-header"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "fullpage-main"
	    }
	  }, [_c('div', {
	    staticClass: "section overlay-container text-center d-flex align-items-center",
	    style: ('background-image: url(' + _vm.slides[0] + ')'),
	    attrs: {
	      "id": "home"
	    }
	  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
	    staticClass: "section white",
	    style: ('background-image: url(' + _vm.slides[1] + ')'),
	    attrs: {
	      "id": "features"
	    }
	  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "section white overlay-container text-center",
	    style: ('background-image: url(' + _vm.slides[4] + ')'),
	    attrs: {
	      "id": "contact_us"
	    }
	  }, [_vm._m(2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container-fluid content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-10 mx-auto"
	  }, [_c('h2', {
	    staticClass: "text-xxl text-light font-2 white"
	  }, [_vm._v("Maximize your cabana revenue!")]), _vm._v(" "), _c('p', {
	    staticClass: "text-l font-2 white"
	  }, [_vm._v("Inventory and Reservation Management | Automated Dynamic Pricing | Real-time Accounting and Reporting")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container content box-middle"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('h2', {
	    staticClass: "text-l text-light font-2 white"
	  }, [_vm._v("Features & Benefits")]), _vm._v(" "), _c('div', {
	    staticClass: "divider white"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "text-m"
	  }, [_c('li', [_vm._v("Capture cabana reservations via the OpenCabana website or mobile application, an embeddable widget that can added to your hotels website")]), _vm._v(" "), _c('li', [_vm._v("Know which cabanas are available in real-time and receive alerts when cabanas are turned over")]), _vm._v(" "), _c('li', [_vm._v("Avoid under-the-table and unauthorized cabana rentals by staff")]), _vm._v(" "), _c('li', [_vm._v("Price your cabanas based on location, date range or occupancy levels")]), _vm._v(" "), _c('li', [_vm._v("Get text or email alerts for comps or discounts and no-shows or cancellations")]), _vm._v(" "), _c('li', [_vm._v("Auto-generate and send email and text discount offers")]), _vm._v(" "), _c('li', [_vm._v("Waitlist option with availability notifications")]), _vm._v(" "), _c('li', [_vm._v("Monitor sales in real-time and generate guest activity and revenue reports")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('h2', {
	    staticClass: "text-l text-light font-2 white"
	  }, [_vm._v("Easy Setup & Minimal Training")]), _vm._v(" "), _c('div', {
	    staticClass: "divider white"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "text-m"
	  }, [_c('li', [_vm._v("No access to any hotel systems needed")]), _vm._v(" "), _c('li', [_vm._v("Minimal tech skills and staff training required")]), _vm._v(" "), _c('li', [_vm._v("OpenCabana is a software as a service (SaaS) solution requiring no software installation and can on your existing computers")]), _vm._v(" "), _c('li', [_vm._v("No need for a POS system. OpenCabana’s mobile checkin tablets can process payments and directly deposit payments into your hotels operating account instantly")]), _vm._v(" "), _c('li', [_vm._v("You only pay for usage based on the number of reservations managed through the system")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container content box-middle"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-12 text-center"
	  }, [_c('p', {
	    staticClass: "text-xl font-2 white margin-bottom"
	  }, [_vm._v("Schedule a 15 minute demo!")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "text-l font-2 white"
	  }, [_vm._v("OpenCabana, LLC")]), _vm._v(" "), _c('p', {
	    staticClass: "font-2 text-m"
	  }, [_vm._v("\n                                  1616 SE 8th Street,"), _c('br'), _vm._v("\n                                  Fort Lauderdale, Florida 33316"), _c('br')])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "text-l font-2 white"
	  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('p', {
	    staticClass: "font-2 text-m"
	  }, [_vm._v("(+1) 954-300-4445"), _c('br'), _vm._v("\n                            corp@opencabana.com")])])])])
	}]}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "footer-links no-print"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 text-center"
	  }, [_c('div', {
	    staticClass: "copyright"
	  }, [_vm._v("© OpenCabana, " + _vm._s(_vm.date) + ".")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-quote no-print"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-8 offset-lg-2 text-center"
	  }, [_c('p', [_vm._v("OpenCabana partners with the world's top resorts to offer and provide VIP beach and poolside cabana services.")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('ul', {
	    staticClass: "footer-links"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#/pages/contact"
	    }
	  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#/hotel-partners"
	    }
	  }, [_vm._v("Hotel Partners")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#/pages/terms"
	    }
	  }, [_vm._v("Terms")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#/pages/privacy"
	    }
	  }, [_vm._v("Privacy")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6 text-right"
	  }, [_c('ul', {
	    staticClass: "social-icons"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/opencabana/",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-facebook-official",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.instagram.com/opencabana/",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-instagram",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.twitter.com/opencabana/",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-twitter",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])])])])
	}]}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrap-footer no-print"
	  }, [(_vm.$route.name !== 'LocationSlug' && _vm.$route.name !== 'ReservationsSlug') ? _c('div', [_c('hr', {
	    staticClass: "space xs border-top"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "footer-content"
	  }, [_c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#features'),
	      expression: "'#features'"
	    }],
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('home')
	      }
	    }
	  }, [_vm._v("FEATURES & BENEFITS")])]), _vm._v(" "), _c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#contact_us'),
	      expression: "'#contact_us'"
	    }],
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('home')
	      }
	    }
	  }, [_vm._v("CONTACT US")])]), _vm._v(" "), _c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('pages/terms')
	      }
	    }
	  }, [_vm._v("TERMS OF USE")])]), _vm._v(" "), _c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('pages/privacy')
	      }
	    }
	  }, [_vm._v("PRIVACY")])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('hr', {
	    staticClass: "space xs"
	  })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("© "), _c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("OpenCabana")]), _vm._v(", " + _vm._s(_vm.date) + ".")], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "social-group"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.facebook.com/opencabana/"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-facebook"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.twitter.com/opencabana/"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-twitter"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.instagram.com/opencabana/"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-instagram"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.youtube.com/channel/UC4guebgvIj1sTBwV4Da3tjg/"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-youtube"
	  })])])
	}]}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "page-copy"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h1', [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('p', [_vm._v("OpenCabana, LLC. and/or its affiliates (\"OpenCabana\") provides its products or services to you subject to the following conditions. If you visit or shop through our Sites, you accept these conditions. Please read them carefully, because they contain important disclosures and information regarding terms of sale, among other terms that may affect your legal rights.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("1. Acceptance of Terms")]), _vm._v(" he \"Terms\" consist of these Conditions of Use, the OpenCabana Privacy Policy and any supplemental terms, legal notices and other communications provided to you. These Terms govern your use of the website offered by OpenCabana at www.OpenCabana.com (including any mobile, touch or other versions) (each a \"Site\"), and all products or services accessed through the Sites (collectively \"Services\"). These Terms constitute a binding legal agreement (\"Agreement,\" though we may use \"Terms\" interchangeably with \"Agreement\" herein) in electronic form between you (\"you,\" \"your\" and/or \"yourself\") and OpenCabana, Inc. and its successors, subsidiaries and affiliates (\"OpenCabana,\" \"we,\" \"us\" and/or \"our\"). By using the Sites and/or Services, you agree to these Terms. IF YOU DO NOT AGREE TO THE TERMS, IMMEDIATELY STOP ACCESSING OR USING ANY OF THE SITES AND/OR SERVICES. BY USING THE SITES AND/OR SERVICES, YOU HAVE ACCEPTED THE TERMS.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2. About the Site")]), _vm._v(" The Site is a platform through which certain third-party hotels (\"Hotels\") sell to Site users (\"Day Guests\") various day passes giving them access to specific Hotel facilities and promotions (\"Day Pass\" or \"Day Passes\"). Hotels are the sellers and issuers of the Day Passes and are solely responsible to you for the condition of the Hotels' facilities, their employees, staff, and personnel and the care, quality, and delivery of the goods and services provided.")]), _vm._v(" "), _c('p', [_vm._v("Day Passes and other available programs and pricing on the Site may change at any time in OpenCabana' sole discretion, without notice.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("3. Electronic Communication")]), _vm._v(" The communications between you and OpenCabana are electronic. You consent to receive communications from OpenCabana in an electronic form. You agree that all terms and conditions, agreements, notices, disclosures and other communications that we provide to you electronically satisfy any legal requirement that such communications would satisfy if they were in writing.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4. Privacy")]), _vm._v(" Your privacy is very important to us. We designed our Privacy Policy to make important disclosures about how we collect, use and protect your personal data. We encourage you to read the Privacy Policy to help make informed decisions when using our Sites and Services. The Privacy Policy is incorporated herein by reference.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("5. Use of the Sites and Services")]), _vm._v(" Your permission to use the Sites and/or Services is conditioned upon your agreement that you: are 18 years of age or older to use the Site; will comply with these Terms; are able to form a binding contract with us; are not prohibited by law from accessing our Sites and/or Services or have not previously been banned, terminated or otherwise denied access to our Sites and/or Services by us; are not acting on behalf of a person whose access to our Sites and/or Services has been previously terminated or otherwise denied by us; will not impersonate another user of the Sites and/or Services.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("6. Access to the Sites and Services")]), _vm._v(" Subject to your compliance with the Terms, we grant you a limited license to access and make personal use of the Sites and/or Services. You are expressly prohibited from: any resale or commercial use of the Sites, the Services, the Contents and/or any of the other contents or materials found thereon; any collection and use of any descriptions, prices or any other information posted on the Site for any purpose other than your own personal use, including, without limitation, any purpose competitive to OpenCabana, the Hotels or any other merchants featured hereunder or any commercial purpose, including marketing; any downloading or copying of Site or account information for any reason other than your personal use, or any use of data mining, robots or similar data gathering and extraction tools; deep-linking to any portion of the Site; framing or utilizing framing techniques to enclose any portion of the Site without express written consent; using the Sites and/or the Services to access or collect any personally identifiable information, including account names, email addresses or other such information for any purpose, including, without limitation, commercial purposes; attempting to gain access to secured portions of the Sites and/or Services to which you do not possess access rights; using the Site and/or Services to generate unsolicited email advertisements or spam; or using any automatic or manual process to search or harvest information from the Sites and/or Services, or interfering in any way with the proper functioning of the Site and/or Services.")]), _vm._v(" "), _c('p', [_vm._v("Any unauthorized use of the Sites, Services, Content and/or any other contents or materials found thereon shall immediately terminate the permission or license granted by us in these Terms.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("7. Your Account")]), _vm._v(" You may register to use the Site by completing the specified registration process and providing us with current, complete, and accurate information as requested by the online registration form. It is your responsibility to maintain the currency, completeness and accuracy of your registration data, and any loss caused by your failure to do so is your responsibility. You agree to notify OpenCabana immediately of any unauthorized use of your account. ")]), _vm._v(" "), _c('p', [_vm._v("You understand and agree that OpenCabana shall have no responsibility for any incident arising out of, or related to, your account settings. You must safeguard your password and supervise the use of your account. You are solely responsible for maintaining the security of your account and maintaining settings that reflect your preferences. We will assume that anyone using the Site or transacting through your account is you. You agree that you are solely responsible for any activity that occurs under your account.")]), _vm._v(" "), _c('p', [_vm._v("The Site may permit you to make purchases without an account or without logging in to your account. If you make a purchase in this manner, we will create an account for you based on the information provided to us in connection with the transaction (e.g., your name, address, e-mail address, and other transaction information).")]), _vm._v(" "), _c('p', [_vm._v("Your account is non-transferrable. You cannot sell, combine, or otherwise share it with any other person. Any violation of these Terms, including, without limitation, failure to maintain updated and correct information about your account (e.g., valid credit card information) will cause your account to fall out of good standing and we may cancel your account in our sole discretion. Upon termination, the provisions of these Terms that are by their nature intended to survive termination (e.g., any disclaimers, all limitations of liability and all indemnities) shall survive.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("8. Terms of Sale")]), _vm._v(" OpenCabana provides consumers with opportunities to book Day Passes from certain third-party Hotels. By purchasing, printing, accepting, using or attempting to use any Day Pass, you agree to these Terms, the Fine Print (defined below) identified on the Day Pass and/or any additional specific terms related to the Day Pass at the time of purchase. These Terms apply to all Day Passes, unless the Fine Print on a particular Day Pass states otherwise, and except as otherwise required by law. In the event of a conflict between these Terms and the Fine Print on a Day Pass, the Fine Print will control, except to the extent prohibited by applicable law.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("How it Works")]), _vm._v(" By booking a Day Pass, you are agreeing to purchase the Day Pass you have selected on the terms, restrictions and conditions associated with the Day Pass. Once you have made your booking , your credit card or other payment mechanism will be charged for the amount of the Day Pass and you will receive confirmation of your booking of the Day Pass.")]), _vm._v(" "), _c('p', [_vm._v("In addition to the terms set forth herein, each Day Pass may come with its own set of restrictions, terms and conditions (collectively, the \"Fine Print,\" whether or not they are expressly labeled as such on a Day Pass). You acknowledge that Hotels may also require you to sign their liability waiver prior to granting you access to their facilities.")]), _vm._v(" "), _c('p', [_vm._v("Unless otherwise stated on the Day Pass or required by law, the following additional terms apply to all Day Passes: The Day Guest must check-in at the Hotel as specified in the instructions of the Day Pass by presenting a valid ID or their booking ID. Day Guests may not redeem Day Passes for cash at the Hotel. Day Passes cannot be used for taxes, tips or redemption of prior balances.")]), _vm._v(" "), _c('p', [_vm._v("If you have disability needs (for example only, you need a wheelchair accessible pool or require the use of a service animal) you must call the Hotel and verify that disability needs can be met. If your disability needs cannot be accommodated by the Hotel, please contact OpenCabana for assistance.")]), _vm._v(" "), _c('p', [_vm._v("Day Pass bookings can be changed or canceled up until 48 hours before the booked date. A full refund will be issued upon cancellation. If for some reason the Day Pass is canceled or rescheduled by us or the Hotel, we will send you an email notifying you prior to such cancelation or rescheduling. If the Day Pass is rescheduled, our email to you will include the new date for the Day Pass. If you cannot make the new date for the Day Pass, you will be entitled to a refund of the amount paid upon request. If, however, the Day Pass is canceled and will not be rescheduled, we will automatically refund you the amount paid.")]), _vm._v(" "), _c('p', [_vm._v("Hotel is the Issuer The Hotel is the issuer of the Day Pass and is solely responsible for receiving Day Guests . The Hotel is also solely responsible for all goods and services it provides to you and for any and all injuries, illnesses, damages, claims, liabilities and costs it may cause you to suffer, directly or indirectly, in full or in part, whether related to the use or redemption of a Day Pass or not, as well as for any unclaimed property liability arising from unredeemed or partially redeemed Day Passes. YOU HEREBY IRREVOCABLY WAIVE ALL RIGHTS RELATED TO, AND RELEASE OPENCABANA AND ITS SUBSIDIARIES, AFFILIATES, PARTNERS, OFFICERS, DIRECTORS, EMPLOYEES AND AGENTS FROM, ANY LIABILITIES ARISING FROM OR RELATED TO ANY ACT OR OMISSION OF A HOTEL IN CONNECTION WITH YOUR USE OF A DAY PASS OR THE PRODUCTS AND/OR SERVICES IT PROVIDES IN CONNECTION WITH IT.")]), _vm._v(" "), _c('p', [_vm._v("Pricing Information The price of Day Passes (or other products and services) will be as dispayed in the booking calendar for each Hotel, except in cases of obvious error. OpenCabana strives to provide accurate pricing information regarding the products and services available on the Site. We cannot, however, insure against pricing errors. OpenCabana reserves the right, at its sole discretion, to not process or to cancel any bookings made for a product or service whose price was incorrectly posted on the site as a result of an error. If this occurs, OpenCabana will notify you by email.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("9. Other Services")]), _vm._v(" In addition to Day Passes, we may from time to time offer some other products and services. We will set forth any terms specific to those products or services at the point of purchase.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("10. Ownership of the Sites and Copyright/Trademarks")]), _vm._v(" The Sites (including past, present and future versions) and all content that are included in, on or that are otherwise a part of the Sites (collectively, the \"Content\") are owned, controlled or licensed by OpenCabana. ")]), _vm._v(" "), _c('p', [_vm._v("The Content is protected by U.S. and international copyright laws and any other applicable intellectual property rules, regulations, and laws. All trademarks, service marks and logos (the \"Trademarks\") displayed on the Site are exclusive property of OpenCabana or the respective owners of the Trademarks. You shall not use the Trademarks in any manner without OpenCabana', or the respective owner's, prior written consent.")]), _vm._v(" "), _c('p', [_vm._v("The Content may not be copied, modified, reproduced, downloaded or distributed in any way, in whole or in part, without the express prior written permission of OpenCabana, unless and except as is expressly provided in these Terms. Any unauthorized use of the Content is prohibited. You agree to abide by any and all additional trademark and copyright notices, information or restrictions contained in any part of the Sites.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("11. Third-Party Links and Contents")]), _vm._v(" Our Sites and/or Services, or communications you receive from our Sites and/or Services may include third-party content or links to third-party websites that we do not control, maintain or endorse. Accessing those third-party sites requires you to leave the Sites and/or Services. We do not control those third-party sites or any of the content contained therein and you expressly acknowledge and agree that we are in no way responsible or liable for any of those third-party sites, including, without limitation, their content, policies, failures, promotions, products, services, actions and/or any damages, losses, failures or problems caused by, related to or arising from those third parties or their sites. YOUR CORRESPONDENCE AND BUSINESS DEALINGS WITH OTHERS FOUND ON OR THROUGH THE SITES AND/OR SERVICES, INCLUDING, WITHOUT LIMITATION, THE PAYMENT AND DELIVERY OF PRODUCTS AND SERVICES, AND ANY TERMS, CONDITIONS, WARRANTIES AND REPRESENTATIONS ASSOCIATED WITH ANY SUCH DEALINGS, ARE SOLELY BETWEEN YOU AND THE THIRD-PARTY. OPENCABANA ENCOURAGES YOU TO REVIEW ALL POLICIES, RULES, TERMS AND REGULATIONS, INCLUDING THE PRIVACY POLICIES AND TERMS OF USE OF EACH AND ANY THIRD-PARTY SITE THAT YOU VISIT.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("12. No Agency Relationship")]), _vm._v(" OpenCabana does not agree to act as your agent or fiduciary in providing services through the Site.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("13. Information and Content Submitted by You")]), _vm._v(" The Sites and Services may offer you the opportunity to post reviews, comments, photos, questions and other content (\"User Content\"). You agree not to post any User Content on any of the Sites and/or Services that is illegal, obscene, threatening, defamatory, invasive of privacy, infringing of intellectual property rights or otherwise injurious to third parties. You further agree not to post any User Content that contains software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of \"spam\". You may not use a false e-mail address, impersonate any person or entity or otherwise mislead as to the origin of User Content. OpenCabana reserves the right (but not the obligation) to remove or edit such User Content, but does not regularly review posted User Content. Any opinions advice, ratings, discussions, comments and/or other User Content of any kind made by you or any user of the Sites and/or Services are those of the respective author(s) or distributor(s) and not of OpenCabana. ")]), _vm._v(" "), _c('p', [_vm._v("If you do post User Content or submit material, and unless we indicate otherwise, you grant OpenCabana a non-exclusive, royalty-free, perpetual, irrevocable and fully sub-licensable right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute and display such User Content throughout the world in any media. You grant OpenCabana and our sublicensees the right to use the name that you submit in connection with such User Content at our discretion. You represent and warrant that you own or otherwise control all of the rights to the User Content that you post, that the User Content is accurate, that use of the User Content you supply does not violate this policy and will not cause injury to any person or entity and that you will indemnify OpenCabana for all claims resulting from User Content you supply. OpenCabana takes no responsibility and assumes no liability for any User Content posted by you or any third party.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("14. Product Submissions")]), _vm._v(" OpenCabana does not accept unsolicited submissions for business ideas, web sites, articles or other products or services. It is our intent to avoid the possibility of future misunderstandings when projects developed by or on behalf of OpenCabana (whether internally or by third parties) might seem to others to be similar to their own creative ideas or materials. Therefore, please do not make any such unsolicited submissions to OpenCabana through the Sites, by email, text message or otherwise. However, if you decide to make any such unsolicited submission, they shall be subject to these Terms and you hereby grant to OpenCabana the irrevocable right and license to the submission as if it were User Content as specifically set forth above.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("15. Termination")]), _vm._v(" If you want to terminate your legal Agreement with OpenCabana, you may do so by: (A) notifying OpenCabana at info@OpenCabana.com or (B) closing your accounts for all of the Services that you use. ")]), _vm._v(" "), _c('p', [_vm._v("OpenCabana may, at any time, terminate this Agreement with you if: (i) you have breached any provision of this Agreement or you do not comply with the Agreement; (ii) OpenCabana is required by law to do so; (iii) the partner with whom OpenCabana has offered the Services to you has terminated its relationship with OpenCabana or ceased to offer the Services to you; (iv) OpenCabana no longer provides Services in the country in which you reside; or (v) OpenCabana determines that the provision of Services to you is no longer commercially viable. Notwithstanding anything contrary in these Terms, OpenCabana reserves the right to discontinue any product or service at any time and at its sole discretion.")]), _vm._v(" "), _c('p', [_vm._v("Without limiting any of the foregoing, OpenCabana may immediately terminate or suspend any User IDs, accounts or passwords in the event of any conduct by you which OpenCabana, in its sole discretion, considers to be unacceptable or in the event of any breach by you of this Agreement. In the event of termination, you agree to immediately cease access to our Sites and Services. Any Day Pass issued prior to termination will be honored according to its terms and the terms of this Agreement specifically applicable to such Day Pass. These Terms will survive termination of this Agreement.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("16. Exclusion of Warranties")]), _vm._v(" WE PROVIDE THE SITES AND SERVICES \"AS IS,\" \"WITH ALL FAULTS\" AND \"AS AVAILABLE,\" UNLESS OTHERWISE SPECIFIED. We make no express or implied representations, warranties or guarantees of any kind about the Sites, Services or any third-party products or services made available to you by us, unless specified in writing. ")]), _vm._v(" "), _c('p', [_vm._v("YOU HEREBY EXPRESSLY AND IRREVOCABLY AGREE THAT YOUR USE OF THIS SITE IS AT YOUR OWN RISK.")]), _vm._v(" "), _c('p', [_vm._v("NOTHING IN THESE TERMS SHALL EXCLUDE OR LIMIT OPENCABANA'S WARRANTY OR LIABILITY FOR LOSSES THAT MAY NOT BE LAWFULLY EXCLUDED OR LIMITED BY APPLICABLE LAW, IF ANY.")]), _vm._v(" "), _c('p', [_vm._v("TO THE MAXIMUM EXTENT PERMITTED BY LAW, OPENCABANA AND OUR OFFICERS, DIRECTORS, AGENTS, VENDORS, MERCHANTS AND THE THIRD-PARTY HOTELS DISCLAIM IMPLIED WARRANTIES THAT THE SITE AND SERVICES ARE MERCHANTABLE, OF SATISFACTORY QUALITY, ACCURATE, TIMELY, FIT FOR A PARTICULAR PURPOSE OR NEED, OR NON-INFRINGING. WE DO NOT GUARANTEE THAT: (A) YOUR USE OF THE SITES AND/OR SERVICES WILL MEET YOUR REQUIREMENTS; (B) YOUR USE OF THE SITES AND/OR SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, AVAILABLE, AND FREE FROM ANY ERROR; (C) ANY PRODUCTS OR SERVICES OBTAINED BY YOU AS A RESULT OF YOUR USE OF THE SITES AND/OR SERVICES WILL BE RELIABLE; OR (D) ELECTRONIC COMMUNICATIONS SENT FROM OPENCABANA WILL BE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE MAKE NO WARRANTIES AS TO PRIVACY AND SECURITY OTHER THAN AS EXPRESSLY STATED IN THE PRIVACY POLICY. ")]), _vm._v(" "), _c('p', [_vm._v("NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY A OPENCABANA REPRESENTATIVE SHALL CREATE A WARRANTY.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("17. Limitation of Liability")]), _vm._v(" SUBJECT TO THE EXCLUSIONS OF WARRANTIES AND ARBITRATION PROVISIONS PROVIDED HEREIN, YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY DISPUTE WITH US IS TO DISCONTINUE YOUR USE OF THE SITES AND SERVICES. YOU EXPRESSLY UNDERSTAND AND AGREE THAT OPENCABANA, ITS AFFILIATES, OFFICERS, DIRECTORS, AGENTS, VENDORS OR MERCHANTS SHALL NOT BE LIABLE TO YOU FOR ANY OF THE FOLLOWING: (A) ANY CLAIMS EXCEEDING THE TOTAL AMOUNT OF FEES THAT YOU PAID US DURING THE PREVIOUS ONE-YEAR PERIOD FOR THE SPECIFIC PRODUCT AND/OR SERVICE AT ISSUE OR (B) ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING FROM YOUR USE OF, INABILITY TO USE OR RELIANCE UPON THE SITES AND SERVICES. THESE EXCLUSIONS APPLY TO, BUT ARE NOT LIMITED TO, ANY CLAIMS FOR LOST PROFITS, LOST DATA, LOSS OF GOODWILL, WORK STOPPAGE, COMPUTER FAILURE OR MALFUNCTION OR ANY OTHER COMMERCIAL DAMAGES OR LOSSES, EVEN IF WE KNEW OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES. IF ANY APPLICABLE JURISDICTION DOES NOT ALLOW THE EXCLUSION OR THE LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, IN SUCH JURISDICTION, OUR LIABILITY, AND THE LIABILITY OF OUR AFFILIATES, OFFICERS, DIRECTORS, AGENTS, VENDORS AND MERCHANTS SHALL BE LIMITED TO THE EXTENT PERMITTED BY LAW.")]), _vm._v(" "), _c('p', [_vm._v("AS SET FORTH ABOVE, YOU AGREE THAT YOU ARE SOLELY RESPONSIBLE FOR INTERACTIONS WITH HOTELS AND OTHER THIRD-PARTY MERCHANTS. SUBJECT TO THE EXCLUSIONS OF WARRANTIES, LIMITATIONS OF LIABILITY AND ARBITRATION PROVISIONS PROVIDED HEREIN, YOU AGREE TO RELEASE OPENCABANA FROM ANY AND ALL CLAIMS OR LIABILITY RELATED TO ANY PRODUCT OR SERVICE OF A HOTEL OR OTHER THIRD-PARTY MERCHANT AND ANY ACTION OR INACTION BY A HOTEL OR OTHER THIRD-PARTY MERCHANT. ")]), _vm._v(" "), _c('p', [_vm._v("ANY HOTEL RATINGS OR REVIEWS DISPLAYED ON THE SITES ARE INTENDED ONLY AS GENERAL GUIDELINES AND OPENCABANA DOES NOT GUARANTEE THE ACCURACY OF THE RATINGS.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("18. Dispute Resolution")]), _vm._v(" Notwithstanding the foregoing, any dispute or claim arising out of or relating in any way to your visit to the Sites, your purchase or redemption of a Day Pass or your use of the services made available through the Sites, these Terms, this Agreement, the Privacy Policy or the validity or enforceability of this arbitration agreement will be resolved by binding arbitration, rather than in court, except for matters that can be taken to small claims court in your local jurisdiction. This agreement and any arbitration shall be governed by the Federal Arbitration Act, and federal arbitration law and the laws of the state of Florida without regard to principles of conflict of laws.")]), _vm._v(" "), _c('p', [_vm._v("There is no judge or jury in arbitration, and court review of an arbitration award is limited. However, an arbitrator can award on an individual basis the same damages and relief (including injunctive and declaratory relief or statutory damages) as a court, and must follow the provisions of these Terms as a court would.")]), _vm._v(" "), _c('p', [_vm._v("We both agree that you or we may bring suit in court to enjoin infringement, unauthorized access or trespass to computer networks or any other misuse, misappropriation or theft of intellectual property rights. We also each agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, consolidated or representative action. The arbitral tribunal shall have the power to rule on any challenge to its own jurisdiction or to the validity or enforceability of any portion of this agreement to arbitrate. If any part of this arbitration provision is held unenforceable, then the balance of this arbitration provision shall remain in effect and shall be construed in accordance with its terms as if the unenforceable provision were not contained. If, however, the class action waiver is found to be unenforceable, then the entire arbitration provision shall be null and void. If for any reason a claim proceeds in court rather than in arbitration we each waive any right to a jury trial and agree that we shall litigate exclusively in the courts located in Fort Lauderdale, California.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("19. Indemnification/Release")]), _vm._v(" You agree to defend, indemnify and hold harmless OpenCabana, its subsidiaries and affiliates and their respective directors, officers, employees and agents from and against all claims and expenses, including, without limitation, attorneys' fees, arising out of, related to, or in connection with any of the following: (a) any Day Pass, products or services purchased by you through the Site or any additional products or services purchased or obtained by you from Hotels or other merchants; (b) any User Content submitted or posted by you, in connection with the Site, or any use of the Site in violation of these Terms; (c) fraud you commit or your intentional misconduct or gross negligence; or (d) your violation of any applicable U.S., Canadian, or foreign law or rights of a third-party. This defense and indemnification obligation will survive the termination of this Agreement and your use of the Sites and/or Services.")]), _vm._v(" "), _c('p', [_vm._v("You are solely responsible for your interactions with Hotels, other merchants and other users of the Site. To the extent permitted under applicable laws, you hereby release OpenCabana from any and all claims or liability related to any product or service of a Hotel or other merchant, regardless of whether such product or service is a Day Pass available through the Site, any action or inaction by a Hotel, including, without limitation, but not limited to any harm caused to you by action or inaction of a Hotel, a Hotel's failure to comply with applicable law and/or failure to abide by the terms of a Day Pass or any other product or service purchased or obtained by you from the Hotel, and any conduct, speech or User Content, whether online or offline, of any other third-party. You agree to waive California Civil Code Section 1542 (if you are a California resident), and any similar provision in any other jurisdiction (if you are a resident of such jurisdiction), which states: \"A general release does not extend to claims which the creditor does not know or suspect to exist in his favor at the time of executing the release, which, if known by him must have materially affected his settlement with the debtor.\"")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("20. Applicable Law")]), _vm._v(" By using our Services, you agree to these Terms and you further agree that any claim or dispute between you and OpenCabana that arises out of this Agreement shall be governed by the laws of the state of Florida without regard to conflict of law principles, except that the arbitration provisions contained herein shall be governed by the Federal Arbitration Act.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("21. Entire Agreement, Changes to this Agreement and Waivers")]), _vm._v(" These Terms, together with the Privacy Policy and any other legal notices published by OpenCabana on the Sites or any Day Pass, shall constitute the entire agreement between you and OpenCabana concerning your use of the Sites and/or Services. We may occasionally change the Terms and the Terms of this Agreement, and any such modifications will become effective once they are posted to the Site. It is your sole responsibility to check the Sites from time to time to view any such changes to the Terms. Your use of the Sites and/or Services after any modifications to the Terms will indicate that you accept and agree to the modified Agreement, provided that these changes will not apply to Day Passes purchased prior to the effective date of such modification. These modifications will however be effective immediately for new users of our Sites and/or Services and for all Day Passes purchased after the effective date of the modification. Any changes to this Agreement (other than as set forth in this paragraph) or waiver of OpenCabana's rights hereunder shall not be valid or effective except in a written agreement bearing the physical signature of an officer of OpenCabana. No purported waiver or modification of this Agreement by OpenCabana via telephonic or email communications shall be valid.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("22. General Terms")]), _vm._v(" You and we are independent contractors, and nothing in this Agreement creates a partnership, employment relationship or agency relationship. There are no third-party beneficiaries of this Agreement. We may assign this Agreement at any time without notice to you. You may not assign this Agreement or your rights and obligations hereunder, in whole or in part, to any third-party without our prior written consent, and any attempt by you to do so will be invalid. Should any part of this Agreement be held invalid or unenforceable, that portion will be construed consistent with applicable law and the remaining portions will remain in full force and effect. Our failure to enforce any provision of this Agreement will not be considered a waiver of the right to enforce such provision. Our rights under this Agreement will survive any termination of this Agreement.")]), _vm._v(" "), _c('p', [_vm._v("YOU AND OPENCABANA AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO OPENCABANA MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.")]), _vm._v(" "), _c('p', [_vm._v("You represent that you are legally able to accept these Terms. You affirm that you are either more than 18 years of age and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations and warranties set forth in this Agreement, and to abide by and comply with this Agreement. If you are not legally able to accept these terms, or refuse to abide by and comply with this Agreement, you must cease use of the Sites and/or Services immediately.")]), _vm._v(" "), _c('p', [_vm._v("Last Updated: April 20, 2018")])])])])])
	}]}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wscn-http404-container"
	  }, [_c('div', {
	    staticClass: "wscn-http404"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "bullshit"
	  }, [_c('div', {
	    staticClass: "bullshit__oops"
	  }, [_vm._v("OOPS!")]), _vm._v(" "), _c('div', {
	    staticClass: "bullshit__info"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bullshit__headline"
	  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
	    staticClass: "bullshit__info"
	  }), _vm._v(" "), _c('a', {
	    staticClass: "bullshit__return-home",
	    attrs: {
	      "href": ""
	    }
	  }, [_vm._v("Home")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pic-404"
	  }, [_c('img', {
	    staticClass: "pic-404__parent",
	    attrs: {
	      "src": "@/assets/404_images/404.png",
	      "alt": "404"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "pic-404__child left",
	    attrs: {
	      "src": "@/assets/404_images/404_cloud.png",
	      "alt": "404"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "pic-404__child mid",
	    attrs: {
	      "src": "@/assets/404_images/404_cloud.png",
	      "alt": "404"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "pic-404__child right",
	    attrs: {
	      "src": "@/assets/404_images/404_cloud.png",
	      "alt": "404"
	    }
	  })])
	}]}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wscn-http401-container"
	  }, [_c('div', {
	    staticClass: "wscn-http401"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "bullshit"
	  }, [_c('div', {
	    staticClass: "bullshit__oops"
	  }, [_vm._v("OOPS!")]), _vm._v(" "), _c('div', {
	    staticClass: "bullshit__info"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bullshit__headline"
	  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
	    staticClass: "bullshit__info"
	  }), _vm._v(" "), _c('a', {
	    staticClass: "bullshit__return-home",
	    attrs: {
	      "href": ""
	    }
	  }, [_vm._v("Home")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pic-401"
	  }, [_c('img', {
	    staticClass: "pic-401__parent",
	    attrs: {
	      "src": "@/assets/401_images/401.png",
	      "alt": "401"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "pic-401__child left",
	    attrs: {
	      "src": "@/assets/401_images/401_cloud.png",
	      "alt": "401"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "pic-401__child mid",
	    attrs: {
	      "src": "@/assets/401_images/401_cloud.png",
	      "alt": "401"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "pic-401__child right",
	    attrs: {
	      "src": "@/assets/401_images/401_cloud.png",
	      "alt": "401"
	    }
	  })])
	}]}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "confirmation"
	    }
	  }, [(_vm.confirmation) ? _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "body text-big text-center"
	  }, [_vm._v("\n        Your reservation has been submitted."), _c('br'), _c('br'), _vm._v("\n\n        You will receive an email and a text with your reservation details "), (_vm.confirmation.email) ? _c('span', [_vm._v("at " + _vm._s(_vm.confirmation.email))]) : _vm._e(), _vm._v("."), _c('br'), _c('br')])]), _c('br'), _vm._v(" "), _vm._m(0)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row no-print"
	  }, [_c('div', {
	    staticClass: "col-12 text-right"
	  }, [_c('a', {
	    staticClass: "btn btn-primary mt-5",
	    attrs: {
	      "href": "#/home"
	    }
	  }, [_vm._v("Done")])])])
	}]}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "search-results"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', [_vm._v("Your Reservations")]), _vm._v(" "), (_vm.reservationLists) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12"
	  }, _vm._l((_vm.reservationLists), function(reservation) {
	    return (_vm.reservationLists.length) ? _c('div', {
	      staticClass: "result"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-lg-5"
	    }, [_c('img', {
	      staticClass: "location-img",
	      attrs: {
	        "src": reservation.location_image
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-7 pl-lg-0"
	    }, [_c('div', {
	      staticClass: "resort-content"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-lg-9"
	    }, [_c('h3', {
	      staticClass: "resort-title",
	      domProps: {
	        "innerHTML": _vm._s(reservation.location_name)
	      }
	    }), _vm._v(" "), _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(reservation.seat_display)
	      }
	    }), _vm._v(" "), _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(reservation.visit_date_display)
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "col-lg-3"
	    }, [_c('span', {
	      staticClass: "resort-city",
	      domProps: {
	        "innerHTML": _vm._s(reservation.amount_display)
	      }
	    })])])]), _vm._v(" "), _c('div', {
	      staticClass: "pull-right"
	    }, [_c('a', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "href": '#/reservations/confirmation/' + reservation.id + ''
	      }
	    }, [_vm._v("Show")]), _vm._v(" "), _c('a', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "href": "javascript: void(0)"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.cancelReservation(reservation)
	        }
	      }
	    }, [_vm._v("Cancel")])])])])]) : _c('div', {
	      staticClass: "result"
	    }, [_vm._m(0)])
	  }), 0)]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12"
	  }, [_c('h1', [_vm._v("Currently you do not have any reservation.")])])])
	}]}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "logo"
	  }, [_c('a', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#home'),
	      expression: "'#home'"
	    }],
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('home')
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(558),
	      "alt": "OpenCabana"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sidebar-menu-wrapper no-print"
	  }, [_c('ul', {
	    staticClass: "sidebar-menu"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [(_vm.routeName !== 'LocationList') ? _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('locations')
	      }
	    }
	  }, [_vm._v("BOOK A CABANA")]) : _vm._e(), _vm._v(" "), (_vm.routeName !== 'home') ? _c('el-button', {
	    attrs: {
	      "type": "warning",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('home')
	      }
	    }
	  }, [_vm._v("Become a Hotel Partner")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "bottom-area text-center"
	  }, [_c('ul', {
	    staticClass: "sidebar-menu"
	  }, [(!_vm.isLoggedIn) ? _c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openSidebarLink('login')
	      }
	    }
	  }, [_vm._v("GUEST LOGIN")])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('li', {
	    staticClass: "sidebar-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.logout.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("LOGOUT")])]) : _vm._e()])])])])
	},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "page-copy"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h1', [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('p', [_vm._v("OpenCabana, LLC. and/or its affiliates (\"OpenCabana\") provides its products or services to you subject to the following conditions. If you visit or shop through our Sites, you accept these conditions. Please read them carefully, because they contain important disclosures and information regarding terms of sale, among other terms that may affect your legal rights.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("1. Acceptance of Terms")]), _vm._v(" he \"Terms\" consist of these Conditions of Use, the OpenCabana Privacy Policy and any supplemental terms, legal notices and other communications provided to you. These Terms govern your use of the website offered by OpenCabana at www.OpenCabana.com (including any mobile, touch or other versions) (each a \"Site\"), and all products or services accessed through the Sites (collectively \"Services\"). These Terms constitute a binding legal agreement (\"Agreement,\" though we may use \"Terms\" interchangeably with \"Agreement\" herein) in electronic form between you (\"you,\" \"your\" and/or \"yourself\") and OpenCabana, Inc. and its successors, subsidiaries and affiliates (\"OpenCabana,\" \"we,\" \"us\" and/or \"our\"). By using the Sites and/or Services, you agree to these Terms. IF YOU DO NOT AGREE TO THE TERMS, IMMEDIATELY STOP ACCESSING OR USING ANY OF THE SITES AND/OR SERVICES. BY USING THE SITES AND/OR SERVICES, YOU HAVE ACCEPTED THE TERMS.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2. About the Site")]), _vm._v(" The Site is a platform through which certain third-party hotels (\"Hotels\") sell to Site users (\"Day Guests\") various day passes giving them access to specific Hotel facilities and promotions (\"Day Pass\" or \"Day Passes\"). Hotels are the sellers and issuers of the Day Passes and are solely responsible to you for the condition of the Hotels' facilities, their employees, staff, and personnel and the care, quality, and delivery of the goods and services provided.")]), _vm._v(" "), _c('p', [_vm._v("Day Passes and other available programs and pricing on the Site may change at any time in OpenCabana' sole discretion, without notice.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("3. Electronic Communication")]), _vm._v(" The communications between you and OpenCabana are electronic. You consent to receive communications from OpenCabana in an electronic form. You agree that all terms and conditions, agreements, notices, disclosures and other communications that we provide to you electronically satisfy any legal requirement that such communications would satisfy if they were in writing.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4. Privacy")]), _vm._v(" Your privacy is very important to us. We designed our Privacy Policy to make important disclosures about how we collect, use and protect your personal data. We encourage you to read the Privacy Policy to help make informed decisions when using our Sites and Services. The Privacy Policy is incorporated herein by reference.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("5. Use of the Sites and Services")]), _vm._v(" Your permission to use the Sites and/or Services is conditioned upon your agreement that you: are 18 years of age or older to use the Site; will comply with these Terms; are able to form a binding contract with us; are not prohibited by law from accessing our Sites and/or Services or have not previously been banned, terminated or otherwise denied access to our Sites and/or Services by us; are not acting on behalf of a person whose access to our Sites and/or Services has been previously terminated or otherwise denied by us; will not impersonate another user of the Sites and/or Services.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("6. Access to the Sites and Services")]), _vm._v(" Subject to your compliance with the Terms, we grant you a limited license to access and make personal use of the Sites and/or Services. You are expressly prohibited from: any resale or commercial use of the Sites, the Services, the Contents and/or any of the other contents or materials found thereon; any collection and use of any descriptions, prices or any other information posted on the Site for any purpose other than your own personal use, including, without limitation, any purpose competitive to OpenCabana, the Hotels or any other merchants featured hereunder or any commercial purpose, including marketing; any downloading or copying of Site or account information for any reason other than your personal use, or any use of data mining, robots or similar data gathering and extraction tools; deep-linking to any portion of the Site; framing or utilizing framing techniques to enclose any portion of the Site without express written consent; using the Sites and/or the Services to access or collect any personally identifiable information, including account names, email addresses or other such information for any purpose, including, without limitation, commercial purposes; attempting to gain access to secured portions of the Sites and/or Services to which you do not possess access rights; using the Site and/or Services to generate unsolicited email advertisements or spam; or using any automatic or manual process to search or harvest information from the Sites and/or Services, or interfering in any way with the proper functioning of the Site and/or Services.")]), _vm._v(" "), _c('p', [_vm._v("Any unauthorized use of the Sites, Services, Content and/or any other contents or materials found thereon shall immediately terminate the permission or license granted by us in these Terms.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("7. Your Account")]), _vm._v(" You may register to use the Site by completing the specified registration process and providing us with current, complete, and accurate information as requested by the online registration form. It is your responsibility to maintain the currency, completeness and accuracy of your registration data, and any loss caused by your failure to do so is your responsibility. You agree to notify OpenCabana immediately of any unauthorized use of your account. ")]), _vm._v(" "), _c('p', [_vm._v("You understand and agree that OpenCabana shall have no responsibility for any incident arising out of, or related to, your account settings. You must safeguard your password and supervise the use of your account. You are solely responsible for maintaining the security of your account and maintaining settings that reflect your preferences. We will assume that anyone using the Site or transacting through your account is you. You agree that you are solely responsible for any activity that occurs under your account.")]), _vm._v(" "), _c('p', [_vm._v("The Site may permit you to make purchases without an account or without logging in to your account. If you make a purchase in this manner, we will create an account for you based on the information provided to us in connection with the transaction (e.g., your name, address, e-mail address, and other transaction information).")]), _vm._v(" "), _c('p', [_vm._v("Your account is non-transferrable. You cannot sell, combine, or otherwise share it with any other person. Any violation of these Terms, including, without limitation, failure to maintain updated and correct information about your account (e.g., valid credit card information) will cause your account to fall out of good standing and we may cancel your account in our sole discretion. Upon termination, the provisions of these Terms that are by their nature intended to survive termination (e.g., any disclaimers, all limitations of liability and all indemnities) shall survive.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("8. Terms of Sale")]), _vm._v(" OpenCabana provides consumers with opportunities to book Day Passes from certain third-party Hotels. By purchasing, printing, accepting, using or attempting to use any Day Pass, you agree to these Terms, the Fine Print (defined below) identified on the Day Pass and/or any additional specific terms related to the Day Pass at the time of purchase. These Terms apply to all Day Passes, unless the Fine Print on a particular Day Pass states otherwise, and except as otherwise required by law. In the event of a conflict between these Terms and the Fine Print on a Day Pass, the Fine Print will control, except to the extent prohibited by applicable law.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("How it Works")]), _vm._v(" By booking a Day Pass, you are agreeing to purchase the Day Pass you have selected on the terms, restrictions and conditions associated with the Day Pass. Once you have made your booking , your credit card or other payment mechanism will be charged for the amount of the Day Pass and you will receive confirmation of your booking of the Day Pass.")]), _vm._v(" "), _c('p', [_vm._v("In addition to the terms set forth herein, each Day Pass may come with its own set of restrictions, terms and conditions (collectively, the \"Fine Print,\" whether or not they are expressly labeled as such on a Day Pass). You acknowledge that Hotels may also require you to sign their liability waiver prior to granting you access to their facilities.")]), _vm._v(" "), _c('p', [_vm._v("Unless otherwise stated on the Day Pass or required by law, the following additional terms apply to all Day Passes: The Day Guest must check-in at the Hotel as specified in the instructions of the Day Pass by presenting a valid ID or their booking ID. Day Guests may not redeem Day Passes for cash at the Hotel. Day Passes cannot be used for taxes, tips or redemption of prior balances.")]), _vm._v(" "), _c('p', [_vm._v("If you have disability needs (for example only, you need a wheelchair accessible pool or require the use of a service animal) you must call the Hotel and verify that disability needs can be met. If your disability needs cannot be accommodated by the Hotel, please contact OpenCabana for assistance.")]), _vm._v(" "), _c('p', [_vm._v("Day Pass bookings can be changed or canceled up until 48 hours before the booked date. A full refund will be issued upon cancellation. If for some reason the Day Pass is canceled or rescheduled by us or the Hotel, we will send you an email notifying you prior to such cancelation or rescheduling. If the Day Pass is rescheduled, our email to you will include the new date for the Day Pass. If you cannot make the new date for the Day Pass, you will be entitled to a refund of the amount paid upon request. If, however, the Day Pass is canceled and will not be rescheduled, we will automatically refund you the amount paid.")]), _vm._v(" "), _c('p', [_vm._v("Hotel is the Issuer The Hotel is the issuer of the Day Pass and is solely responsible for receiving Day Guests . The Hotel is also solely responsible for all goods and services it provides to you and for any and all injuries, illnesses, damages, claims, liabilities and costs it may cause you to suffer, directly or indirectly, in full or in part, whether related to the use or redemption of a Day Pass or not, as well as for any unclaimed property liability arising from unredeemed or partially redeemed Day Passes. YOU HEREBY IRREVOCABLY WAIVE ALL RIGHTS RELATED TO, AND RELEASE OPENCABANA AND ITS SUBSIDIARIES, AFFILIATES, PARTNERS, OFFICERS, DIRECTORS, EMPLOYEES AND AGENTS FROM, ANY LIABILITIES ARISING FROM OR RELATED TO ANY ACT OR OMISSION OF A HOTEL IN CONNECTION WITH YOUR USE OF A DAY PASS OR THE PRODUCTS AND/OR SERVICES IT PROVIDES IN CONNECTION WITH IT.")]), _vm._v(" "), _c('p', [_vm._v("Pricing Information The price of Day Passes (or other products and services) will be as dispayed in the booking calendar for each Hotel, except in cases of obvious error. OpenCabana strives to provide accurate pricing information regarding the products and services available on the Site. We cannot, however, insure against pricing errors. OpenCabana reserves the right, at its sole discretion, to not process or to cancel any bookings made for a product or service whose price was incorrectly posted on the site as a result of an error. If this occurs, OpenCabana will notify you by email.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("9. Other Services")]), _vm._v(" In addition to Day Passes, we may from time to time offer some other products and services. We will set forth any terms specific to those products or services at the point of purchase.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("10. Ownership of the Sites and Copyright/Trademarks")]), _vm._v(" The Sites (including past, present and future versions) and all content that are included in, on or that are otherwise a part of the Sites (collectively, the \"Content\") are owned, controlled or licensed by OpenCabana. ")]), _vm._v(" "), _c('p', [_vm._v("The Content is protected by U.S. and international copyright laws and any other applicable intellectual property rules, regulations, and laws. All trademarks, service marks and logos (the \"Trademarks\") displayed on the Site are exclusive property of OpenCabana or the respective owners of the Trademarks. You shall not use the Trademarks in any manner without OpenCabana', or the respective owner's, prior written consent.")]), _vm._v(" "), _c('p', [_vm._v("The Content may not be copied, modified, reproduced, downloaded or distributed in any way, in whole or in part, without the express prior written permission of OpenCabana, unless and except as is expressly provided in these Terms. Any unauthorized use of the Content is prohibited. You agree to abide by any and all additional trademark and copyright notices, information or restrictions contained in any part of the Sites.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("11. Third-Party Links and Contents")]), _vm._v(" Our Sites and/or Services, or communications you receive from our Sites and/or Services may include third-party content or links to third-party websites that we do not control, maintain or endorse. Accessing those third-party sites requires you to leave the Sites and/or Services. We do not control those third-party sites or any of the content contained therein and you expressly acknowledge and agree that we are in no way responsible or liable for any of those third-party sites, including, without limitation, their content, policies, failures, promotions, products, services, actions and/or any damages, losses, failures or problems caused by, related to or arising from those third parties or their sites. YOUR CORRESPONDENCE AND BUSINESS DEALINGS WITH OTHERS FOUND ON OR THROUGH THE SITES AND/OR SERVICES, INCLUDING, WITHOUT LIMITATION, THE PAYMENT AND DELIVERY OF PRODUCTS AND SERVICES, AND ANY TERMS, CONDITIONS, WARRANTIES AND REPRESENTATIONS ASSOCIATED WITH ANY SUCH DEALINGS, ARE SOLELY BETWEEN YOU AND THE THIRD-PARTY. OPENCABANA ENCOURAGES YOU TO REVIEW ALL POLICIES, RULES, TERMS AND REGULATIONS, INCLUDING THE PRIVACY POLICIES AND TERMS OF USE OF EACH AND ANY THIRD-PARTY SITE THAT YOU VISIT.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("12. No Agency Relationship")]), _vm._v(" OpenCabana does not agree to act as your agent or fiduciary in providing services through the Site.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("13. Information and Content Submitted by You")]), _vm._v(" The Sites and Services may offer you the opportunity to post reviews, comments, photos, questions and other content (\"User Content\"). You agree not to post any User Content on any of the Sites and/or Services that is illegal, obscene, threatening, defamatory, invasive of privacy, infringing of intellectual property rights or otherwise injurious to third parties. You further agree not to post any User Content that contains software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of \"spam\". You may not use a false e-mail address, impersonate any person or entity or otherwise mislead as to the origin of User Content. OpenCabana reserves the right (but not the obligation) to remove or edit such User Content, but does not regularly review posted User Content. Any opinions advice, ratings, discussions, comments and/or other User Content of any kind made by you or any user of the Sites and/or Services are those of the respective author(s) or distributor(s) and not of OpenCabana. ")]), _vm._v(" "), _c('p', [_vm._v("If you do post User Content or submit material, and unless we indicate otherwise, you grant OpenCabana a non-exclusive, royalty-free, perpetual, irrevocable and fully sub-licensable right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute and display such User Content throughout the world in any media. You grant OpenCabana and our sublicensees the right to use the name that you submit in connection with such User Content at our discretion. You represent and warrant that you own or otherwise control all of the rights to the User Content that you post, that the User Content is accurate, that use of the User Content you supply does not violate this policy and will not cause injury to any person or entity and that you will indemnify OpenCabana for all claims resulting from User Content you supply. OpenCabana takes no responsibility and assumes no liability for any User Content posted by you or any third party.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("14. Product Submissions")]), _vm._v(" OpenCabana does not accept unsolicited submissions for business ideas, web sites, articles or other products or services. It is our intent to avoid the possibility of future misunderstandings when projects developed by or on behalf of OpenCabana (whether internally or by third parties) might seem to others to be similar to their own creative ideas or materials. Therefore, please do not make any such unsolicited submissions to OpenCabana through the Sites, by email, text message or otherwise. However, if you decide to make any such unsolicited submission, they shall be subject to these Terms and you hereby grant to OpenCabana the irrevocable right and license to the submission as if it were User Content as specifically set forth above.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("15. Termination")]), _vm._v(" If you want to terminate your legal Agreement with OpenCabana, you may do so by: (A) notifying OpenCabana at info@OpenCabana.com or (B) closing your accounts for all of the Services that you use. ")]), _vm._v(" "), _c('p', [_vm._v("OpenCabana may, at any time, terminate this Agreement with you if: (i) you have breached any provision of this Agreement or you do not comply with the Agreement; (ii) OpenCabana is required by law to do so; (iii) the partner with whom OpenCabana has offered the Services to you has terminated its relationship with OpenCabana or ceased to offer the Services to you; (iv) OpenCabana no longer provides Services in the country in which you reside; or (v) OpenCabana determines that the provision of Services to you is no longer commercially viable. Notwithstanding anything contrary in these Terms, OpenCabana reserves the right to discontinue any product or service at any time and at its sole discretion.")]), _vm._v(" "), _c('p', [_vm._v("Without limiting any of the foregoing, OpenCabana may immediately terminate or suspend any User IDs, accounts or passwords in the event of any conduct by you which OpenCabana, in its sole discretion, considers to be unacceptable or in the event of any breach by you of this Agreement. In the event of termination, you agree to immediately cease access to our Sites and Services. Any Day Pass issued prior to termination will be honored according to its terms and the terms of this Agreement specifically applicable to such Day Pass. These Terms will survive termination of this Agreement.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("16. Exclusion of Warranties")]), _vm._v(" WE PROVIDE THE SITES AND SERVICES \"AS IS,\" \"WITH ALL FAULTS\" AND \"AS AVAILABLE,\" UNLESS OTHERWISE SPECIFIED. We make no express or implied representations, warranties or guarantees of any kind about the Sites, Services or any third-party products or services made available to you by us, unless specified in writing. ")]), _vm._v(" "), _c('p', [_vm._v("YOU HEREBY EXPRESSLY AND IRREVOCABLY AGREE THAT YOUR USE OF THIS SITE IS AT YOUR OWN RISK.")]), _vm._v(" "), _c('p', [_vm._v("NOTHING IN THESE TERMS SHALL EXCLUDE OR LIMIT OPENCABANA'S WARRANTY OR LIABILITY FOR LOSSES THAT MAY NOT BE LAWFULLY EXCLUDED OR LIMITED BY APPLICABLE LAW, IF ANY.")]), _vm._v(" "), _c('p', [_vm._v("TO THE MAXIMUM EXTENT PERMITTED BY LAW, OPENCABANA AND OUR OFFICERS, DIRECTORS, AGENTS, VENDORS, MERCHANTS AND THE THIRD-PARTY HOTELS DISCLAIM IMPLIED WARRANTIES THAT THE SITE AND SERVICES ARE MERCHANTABLE, OF SATISFACTORY QUALITY, ACCURATE, TIMELY, FIT FOR A PARTICULAR PURPOSE OR NEED, OR NON-INFRINGING. WE DO NOT GUARANTEE THAT: (A) YOUR USE OF THE SITES AND/OR SERVICES WILL MEET YOUR REQUIREMENTS; (B) YOUR USE OF THE SITES AND/OR SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, AVAILABLE, AND FREE FROM ANY ERROR; (C) ANY PRODUCTS OR SERVICES OBTAINED BY YOU AS A RESULT OF YOUR USE OF THE SITES AND/OR SERVICES WILL BE RELIABLE; OR (D) ELECTRONIC COMMUNICATIONS SENT FROM OPENCABANA WILL BE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE MAKE NO WARRANTIES AS TO PRIVACY AND SECURITY OTHER THAN AS EXPRESSLY STATED IN THE PRIVACY POLICY. ")]), _vm._v(" "), _c('p', [_vm._v("NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY A OPENCABANA REPRESENTATIVE SHALL CREATE A WARRANTY.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("17. Limitation of Liability")]), _vm._v(" SUBJECT TO THE EXCLUSIONS OF WARRANTIES AND ARBITRATION PROVISIONS PROVIDED HEREIN, YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY DISPUTE WITH US IS TO DISCONTINUE YOUR USE OF THE SITES AND SERVICES. YOU EXPRESSLY UNDERSTAND AND AGREE THAT OPENCABANA, ITS AFFILIATES, OFFICERS, DIRECTORS, AGENTS, VENDORS OR MERCHANTS SHALL NOT BE LIABLE TO YOU FOR ANY OF THE FOLLOWING: (A) ANY CLAIMS EXCEEDING THE TOTAL AMOUNT OF FEES THAT YOU PAID US DURING THE PREVIOUS ONE-YEAR PERIOD FOR THE SPECIFIC PRODUCT AND/OR SERVICE AT ISSUE OR (B) ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING FROM YOUR USE OF, INABILITY TO USE OR RELIANCE UPON THE SITES AND SERVICES. THESE EXCLUSIONS APPLY TO, BUT ARE NOT LIMITED TO, ANY CLAIMS FOR LOST PROFITS, LOST DATA, LOSS OF GOODWILL, WORK STOPPAGE, COMPUTER FAILURE OR MALFUNCTION OR ANY OTHER COMMERCIAL DAMAGES OR LOSSES, EVEN IF WE KNEW OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES. IF ANY APPLICABLE JURISDICTION DOES NOT ALLOW THE EXCLUSION OR THE LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, IN SUCH JURISDICTION, OUR LIABILITY, AND THE LIABILITY OF OUR AFFILIATES, OFFICERS, DIRECTORS, AGENTS, VENDORS AND MERCHANTS SHALL BE LIMITED TO THE EXTENT PERMITTED BY LAW.")]), _vm._v(" "), _c('p', [_vm._v("AS SET FORTH ABOVE, YOU AGREE THAT YOU ARE SOLELY RESPONSIBLE FOR INTERACTIONS WITH HOTELS AND OTHER THIRD-PARTY MERCHANTS. SUBJECT TO THE EXCLUSIONS OF WARRANTIES, LIMITATIONS OF LIABILITY AND ARBITRATION PROVISIONS PROVIDED HEREIN, YOU AGREE TO RELEASE OPENCABANA FROM ANY AND ALL CLAIMS OR LIABILITY RELATED TO ANY PRODUCT OR SERVICE OF A HOTEL OR OTHER THIRD-PARTY MERCHANT AND ANY ACTION OR INACTION BY A HOTEL OR OTHER THIRD-PARTY MERCHANT. ")]), _vm._v(" "), _c('p', [_vm._v("ANY HOTEL RATINGS OR REVIEWS DISPLAYED ON THE SITES ARE INTENDED ONLY AS GENERAL GUIDELINES AND OPENCABANA DOES NOT GUARANTEE THE ACCURACY OF THE RATINGS.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("18. Dispute Resolution")]), _vm._v(" Notwithstanding the foregoing, any dispute or claim arising out of or relating in any way to your visit to the Sites, your purchase or redemption of a Day Pass or your use of the services made available through the Sites, these Terms, this Agreement, the Privacy Policy or the validity or enforceability of this arbitration agreement will be resolved by binding arbitration, rather than in court, except for matters that can be taken to small claims court in your local jurisdiction. This agreement and any arbitration shall be governed by the Federal Arbitration Act, and federal arbitration law and the laws of the state of Florida without regard to principles of conflict of laws.")]), _vm._v(" "), _c('p', [_vm._v("There is no judge or jury in arbitration, and court review of an arbitration award is limited. However, an arbitrator can award on an individual basis the same damages and relief (including injunctive and declaratory relief or statutory damages) as a court, and must follow the provisions of these Terms as a court would.")]), _vm._v(" "), _c('p', [_vm._v("We both agree that you or we may bring suit in court to enjoin infringement, unauthorized access or trespass to computer networks or any other misuse, misappropriation or theft of intellectual property rights. We also each agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, consolidated or representative action. The arbitral tribunal shall have the power to rule on any challenge to its own jurisdiction or to the validity or enforceability of any portion of this agreement to arbitrate. If any part of this arbitration provision is held unenforceable, then the balance of this arbitration provision shall remain in effect and shall be construed in accordance with its terms as if the unenforceable provision were not contained. If, however, the class action waiver is found to be unenforceable, then the entire arbitration provision shall be null and void. If for any reason a claim proceeds in court rather than in arbitration we each waive any right to a jury trial and agree that we shall litigate exclusively in the courts located in Fort Lauderdale, California.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("19. Indemnification/Release")]), _vm._v(" You agree to defend, indemnify and hold harmless OpenCabana, its subsidiaries and affiliates and their respective directors, officers, employees and agents from and against all claims and expenses, including, without limitation, attorneys' fees, arising out of, related to, or in connection with any of the following: (a) any Day Pass, products or services purchased by you through the Site or any additional products or services purchased or obtained by you from Hotels or other merchants; (b) any User Content submitted or posted by you, in connection with the Site, or any use of the Site in violation of these Terms; (c) fraud you commit or your intentional misconduct or gross negligence; or (d) your violation of any applicable U.S., Canadian, or foreign law or rights of a third-party. This defense and indemnification obligation will survive the termination of this Agreement and your use of the Sites and/or Services.")]), _vm._v(" "), _c('p', [_vm._v("You are solely responsible for your interactions with Hotels, other merchants and other users of the Site. To the extent permitted under applicable laws, you hereby release OpenCabana from any and all claims or liability related to any product or service of a Hotel or other merchant, regardless of whether such product or service is a Day Pass available through the Site, any action or inaction by a Hotel, including, without limitation, but not limited to any harm caused to you by action or inaction of a Hotel, a Hotel's failure to comply with applicable law and/or failure to abide by the terms of a Day Pass or any other product or service purchased or obtained by you from the Hotel, and any conduct, speech or User Content, whether online or offline, of any other third-party. You agree to waive California Civil Code Section 1542 (if you are a California resident), and any similar provision in any other jurisdiction (if you are a resident of such jurisdiction), which states: \"A general release does not extend to claims which the creditor does not know or suspect to exist in his favor at the time of executing the release, which, if known by him must have materially affected his settlement with the debtor.\"")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("20. Applicable Law")]), _vm._v(" By using our Services, you agree to these Terms and you further agree that any claim or dispute between you and OpenCabana that arises out of this Agreement shall be governed by the laws of the state of Florida without regard to conflict of law principles, except that the arbitration provisions contained herein shall be governed by the Federal Arbitration Act.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("21. Entire Agreement, Changes to this Agreement and Waivers")]), _vm._v(" These Terms, together with the Privacy Policy and any other legal notices published by OpenCabana on the Sites or any Day Pass, shall constitute the entire agreement between you and OpenCabana concerning your use of the Sites and/or Services. We may occasionally change the Terms and the Terms of this Agreement, and any such modifications will become effective once they are posted to the Site. It is your sole responsibility to check the Sites from time to time to view any such changes to the Terms. Your use of the Sites and/or Services after any modifications to the Terms will indicate that you accept and agree to the modified Agreement, provided that these changes will not apply to Day Passes purchased prior to the effective date of such modification. These modifications will however be effective immediately for new users of our Sites and/or Services and for all Day Passes purchased after the effective date of the modification. Any changes to this Agreement (other than as set forth in this paragraph) or waiver of OpenCabana's rights hereunder shall not be valid or effective except in a written agreement bearing the physical signature of an officer of OpenCabana. No purported waiver or modification of this Agreement by OpenCabana via telephonic or email communications shall be valid.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("22. General Terms")]), _vm._v(" You and we are independent contractors, and nothing in this Agreement creates a partnership, employment relationship or agency relationship. There are no third-party beneficiaries of this Agreement. We may assign this Agreement at any time without notice to you. You may not assign this Agreement or your rights and obligations hereunder, in whole or in part, to any third-party without our prior written consent, and any attempt by you to do so will be invalid. Should any part of this Agreement be held invalid or unenforceable, that portion will be construed consistent with applicable law and the remaining portions will remain in full force and effect. Our failure to enforce any provision of this Agreement will not be considered a waiver of the right to enforce such provision. Our rights under this Agreement will survive any termination of this Agreement.")]), _vm._v(" "), _c('p', [_vm._v("YOU AND OPENCABANA AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO OPENCABANA MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.")]), _vm._v(" "), _c('p', [_vm._v("You represent that you are legally able to accept these Terms. You affirm that you are either more than 18 years of age and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations and warranties set forth in this Agreement, and to abide by and comply with this Agreement. If you are not legally able to accept these terms, or refuse to abide by and comply with this Agreement, you must cease use of the Sites and/or Services immediately.")]), _vm._v(" "), _c('p', [_vm._v("Last Updated: April 20, 2018")])])])])])
	}]}

/***/ }),
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./app.js": 387,
		"./permission.js": 388,
		"./user.js": 389
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 617;


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.2468a13b60bd905c4e90.js